// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/dropdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/MonaSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/MonaSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/MonaSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/MonaSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/MonaSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/MonaSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../src/assets/images/widget-vector.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/images/dropdown-nofill.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sometype+Mono:wght@400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: "Mona Sans", sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1440px){

  .container{
    max-width: 1440px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
@media (min-width: 1700px){

  .container{
    max-width: 1700px;
  }
}
input,
  select{
  height: 3rem;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
  outline-style: solid;
  outline-width: 0.5px;
  outline-color: #D5D5D5;
}
input::placeholder,
  select::placeholder{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
input[data-bg='white']{
  height: 3rem;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
  outline-style: solid;
  outline-width: 0.5px;
  outline-color: #D5D5D5;
}
input[data-bg='white']::placeholder{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
select[data-smallerselect]{
  height: 28px;
  width: 8rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0.5rem;
  padding-right: 1.75rem;
  padding-top: 0.25rem;
  font-size: .625rem;
  line-height: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(8 9 23 / var(--tw-text-opacity, 1));
  outline-style: solid;
  outline-width: 0.5px;
  outline-color: #D5D5D5;
}
select[data-smallerselect]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
textarea{
  height: 8rem;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  font-size: .8125rem;
  line-height: 18px;
  outline-style: solid;
  outline-width: 0.5px;
  outline-color: #D5D5D5;
}
textarea::placeholder{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
textarea[data-smallertextarea]{
  height: 5.5rem;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  outline-style: solid;
  outline-width: 0.5px;
  outline-color: #D5D5D5;
}
textarea[data-smallertextarea]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
input[type='checkbox']{
  cursor: pointer;
  outline-style: solid;
}
label{
  display: flex;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  font-size: .8125rem;
  line-height: 18px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(78 78 78 / var(--tw-text-opacity, 1));
}
label[data-smallerlabel]{
  display: flex;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  font-size: .625rem;
  line-height: 12px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(78 78 78 / var(--tw-text-opacity, 1));
}
input[type='search']:focus-visible,
  input:focus-visible,
  input:focus-within,
  select:focus-visible,
  textarea:focus-visible{
  outline-style: solid;
  outline-width: 1px;
  outline-color: var(--color-primary);
}
input[type='search']{
  height: 36px;
  border-radius: 0.5rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2.5rem;
  font-size: .8125rem;
  line-height: 18px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(174 179 199 / var(--tw-text-opacity, 1));
  outline-width: 1px;
  outline-color: #EBEBEB;
}
input[type='radio'],
  input[type='checkbox']{
  accent-color: var(--color-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
}
input[type='date'] {
    position: relative;
    height: 48px;
    width: 100%;
  }
/*noinspection CssOverwrittenProperties*/
input[type='date']::-webkit-calendar-picker-indicator {
    position: absolute;
    transform: scaleX(-1);
    cursor: pointer;
    right: 16px;
    padding: 16px;
    margin-right: -16px;
    padding-left: 16px;
    width: 100%;
  }
button:disabled{
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(133 133 142 / var(--tw-text-opacity, 1));
}
button:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(133 133 142 / var(--tw-text-opacity, 1));
}
.card-link{
  border-width: 1px;
  border-color: transparent;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.card-link:hover{
  --tw-border-opacity: 1;
  border-color: rgb(159 189 237 / var(--tw-border-opacity, 1));
}
.card-link:active{
  --tw-border-opacity: 1;
  border-color: rgb(217 229 248 / var(--tw-border-opacity, 1));
}
.tooltip{
  visibility: hidden;
  position: absolute;
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.has-tooltip:hover .tooltip{
  visibility: visible;
  z-index: 50;
  opacity: 1;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
iframe#webpack-dev-server-client-overlay {
    display: none !important;
  }
.secondary_button {
    background: linear-gradient(
        0deg,
        var(--White, #ffffff),
        var(--White, #ffffff)
      ),
      linear-gradient(
        180deg,
        rgba(223, 225, 231, 0) 0%,
        rgba(223, 225, 231, 0.05) 100%
      );
    border: 1px solid #12376914;
    box-shadow: 0px -1px 2px 0px #12376914 inset;
  }
.primary_button {
    position: relative;
    border: none;
    z-index: 1;
  }
.primary_button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    padding: 1px; /* Border width */
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
  }
.tooltip::before {
    content: '';
    position: absolute;
    top: -14px;
    border-width: 8px;
    border-style: solid;
    border-color: #444771 transparent transparent transparent;
    transform: rotate(180deg);
  }
.google-translate-dropdown{
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: var(--color-primary);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
  font-size: .8125rem;
  line-height: 18px;
  color: var(--color-primary);
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.google-translate-dropdown .goog-te-gadget-simple {
    border: none !important;
    display: flex !important;
  }
.google-translate-dropdown .goog-te-gadget-simple span a {
    display: flex !important;
  }
.logs-tr .logs-code span {
    /* display: none; */
    transition: all 0.5s ease-in-out;
    transform: translateX(-3px);
    visibility: hidden;
    opacity: 0;
    width: 2px;
  }
.logs-tr:hover .logs-code span {
    /* display: block; */
    visibility: visible;
    transform: translateX(3px);
    transition: 0.3s ease-in-out;
    width: 100%;
    opacity: 1;
  }
select {
    /* for Firefox */
    appearance: none;
    /* for Safari, Chrome, Opera */
    -webkit-appearance: none;
    font-size: 14px;
    color: #080917;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right white;
    background-position-x: calc(100% - 16px);
  }
select[data-smallerselect] {
    background-position-x: calc(100% - 8px);
  }
/* for IE */
select::-ms-expand {
    display: none;
  }
input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
/* Firefox */
input[type='number'] {
    appearance: none;
  }
.nav-item.active,
  .nav-item:hover {
    background-color: #ffffff;
    border: 1px solid #dfe0df;
    box-shadow: 0px 1px 2px 0px #344272;
    border-radius: 8px;
    color: #0b1c56;
  }
.nav-sub-item {
    background-color: #0e122a !important;
    color: white;
  }
.nav-sub-item-veldro.active,
  .nav-sub-item-veldro:hover {
    background-color: #d4b8e0 !important;
  }
.nav-item:hover svg path,
  .sub-nav-item:hover svg path {
    fill: #0b1c56 !important;
  }
.nav-sub-item.active,
  .nav-sub-item:hover {
    background-color: #121635 !important;
  }
.nav-item.active svg path {
    fill: #0b1c56 !important;
  }
.sub-nav-item.active {
    background-color: #ffffff !important;
    color: #0b1c56 !important;
  }
.sub-nav-item.active svg path {
    fill: #0b1c56 !important;
  }
.nav-sub-item-profiled-risk {
    background-color: #1e2060 !important;
    color: #ffffff;
  }
.nav-sub-item-profiled-risk.active,
  .nav-sub-item-profiled-risk:hover {
    background-color: #161c3f !important;
  }
aside a {
    white-space: nowrap;
  }
.nav-sub-item-profiled-risk {
    background-color: #1e2060 !important;
    color: #ffffff;
  }
.nav-sub-item-profiled-risk.active,
  .nav-sub-item-profiled-risk:hover {
    background-color: #161c3f !important;
  }
.nav-sub-item-trypila {
    background-color: #451480d4 !important;
    color: #ffffff;
  }
.nav-sub-item-trypila.active,
  .nav-sub-item-trypila:hover {
    background-color: #54159f !important;
  }
.scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
aside svg {
    width: 18px;
    height: 18px;
  }
.logo {
    display: none;
  }
/* activity log styling */
.activity-parent {
    grid-template-columns: 0.8fr 4fr;
  }
.activity-description:before {
    transform: translate(-50%, -50%);
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-2{
  bottom: -0.5rem;
}
.-bottom-\\[3px\\]{
  bottom: -3px;
}
.-left-3{
  left: -0.75rem;
}
.-left-6{
  left: -1.5rem;
}
.-left-\\[11px\\]{
  left: -11px;
}
.-left-\\[32px\\]{
  left: -32px;
}
.-left-\\[3px\\]{
  left: -3px;
}
.-right-1{
  right: -0.25rem;
}
.-right-10{
  right: -2.5rem;
}
.-right-5{
  right: -1.25rem;
}
.-right-6{
  right: -1.5rem;
}
.-right-\\[-112px\\]{
  right: 112px;
}
.-right-\\[164px\\]{
  right: -164px;
}
.-right-\\[17px\\]{
  right: -17px;
}
.-right-\\[41px\\]{
  right: -41px;
}
.-top-10{
  top: -2.5rem;
}
.-top-\\[52px\\]{
  top: -52px;
}
.-top-\\[58px\\]{
  top: -58px;
}
.-top-\\[5px\\]{
  top: -5px;
}
.-top-\\[90px\\]{
  top: -90px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-0\\.5{
  bottom: 0.125rem;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-12{
  bottom: 3rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-\\[0\\.1px\\]{
  bottom: 0.1px;
}
.bottom-\\[118\\%\\]{
  bottom: 118%;
}
.bottom-\\[14px\\]{
  bottom: 14px;
}
.bottom-\\[19px\\]{
  bottom: 19px;
}
.bottom-\\[1px\\]{
  bottom: 1px;
}
.bottom-\\[2px\\]{
  bottom: 2px;
}
.bottom-\\[3px\\]{
  bottom: 3px;
}
.bottom-\\[8px\\]{
  bottom: 8px;
}
.bottom-\\[9px\\]{
  bottom: 9px;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-20{
  left: 5rem;
}
.left-4{
  left: 1rem;
}
.left-7{
  left: 1.75rem;
}
.left-\\[-0\\.5rem\\]{
  left: -0.5rem;
}
.left-\\[-1px\\]{
  left: -1px;
}
.left-\\[-6px\\]{
  left: -6px;
}
.left-\\[-9px\\]{
  left: -9px;
}
.left-\\[13px\\]{
  left: 13px;
}
.left-\\[150px\\]{
  left: 150px;
}
.left-\\[16px\\]{
  left: 16px;
}
.left-\\[23px\\]{
  left: 23px;
}
.left-\\[370px\\]{
  left: 370px;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-10{
  right: 2.5rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-6{
  right: 1.5rem;
}
.right-8{
  right: 2rem;
}
.right-\\[-0\\.5rem\\]{
  right: -0.5rem;
}
.right-\\[-6px\\]{
  right: -6px;
}
.right-\\[-9px\\]{
  right: -9px;
}
.right-\\[165px\\]{
  right: 165px;
}
.right-\\[16px\\]{
  right: 16px;
}
.right-\\[240px\\]{
  right: 240px;
}
.right-\\[24px\\]{
  right: 24px;
}
.right-\\[257px\\]{
  right: 257px;
}
.right-\\[380px\\]{
  right: 380px;
}
.right-\\[43\\%\\]{
  right: 43%;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-12{
  top: 3rem;
}
.top-2{
  top: 0.5rem;
}
.top-2\\/4{
  top: 50%;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-9{
  top: 2.25rem;
}
.top-\\[1\\.8px\\]{
  top: 1.8px;
}
.top-\\[14px\\]{
  top: 14px;
}
.top-\\[25px\\]{
  top: 25px;
}
.top-\\[2px\\]{
  top: 2px;
}
.top-\\[3px\\]{
  top: 3px;
}
.top-\\[41px\\]{
  top: 41px;
}
.top-\\[51px\\]{
  top: 51px;
}
.top-\\[6px\\]{
  top: 6px;
}
.top-\\[9px\\]{
  top: 9px;
}
.top-full{
  top: 100%;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[-1\\]{
  z-index: -1;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.z-\\[99\\]{
  z-index: 99;
}
.z-\\[9\\]{
  z-index: 9;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-full{
  grid-column: 1 / -1;
}
.m-0{
  margin: 0px;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-6{
  margin: 1.5rem;
}
.m-\\[1px\\]{
  margin: 1px;
}
.m-auto{
  margin: auto;
}
.\\!mx-\\[0px\\]{
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.-mx-20{
  margin-left: -5rem;
  margin-right: -5rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-mx-8{
  margin-left: -2rem;
  margin-right: -2rem;
}
.-mx-\\[26px\\]{
  margin-left: -26px;
  margin-right: -26px;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5{
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-20{
  margin-left: 5rem;
  margin-right: 5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-\\[-12px\\]{
  margin-left: -12px;
  margin-right: -12px;
}
.mx-\\[-32px\\]{
  margin-left: -32px;
  margin-right: -32px;
}
.mx-\\[0px\\]{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-\\[80px\\]{
  margin-left: 80px;
  margin-right: 80px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-9{
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.\\!mb-0{
  margin-bottom: 0px !important;
}
.\\!ml-0{
  margin-left: 0px !important;
}
.\\!ml-6{
  margin-left: 1.5rem !important;
}
.\\!mt-3{
  margin-top: 0.75rem !important;
}
.\\!mt-8{
  margin-top: 2rem !important;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.-mb-2{
  margin-bottom: -0.5rem;
}
.-mb-\\[2px\\]{
  margin-bottom: -2px;
}
.-ml-12{
  margin-left: -3rem;
}
.-mr-4{
  margin-right: -1rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-\\[2px\\]{
  margin-top: -2px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.mb-\\[1px\\]{
  margin-bottom: 1px;
}
.mb-\\[2px\\]{
  margin-bottom: 2px;
}
.mb-\\[3px\\]{
  margin-bottom: 3px;
}
.mb-\\[40px\\]{
  margin-bottom: 40px;
}
.mb-\\[5px\\]{
  margin-bottom: 5px;
}
.mb-\\[6px\\]{
  margin-bottom: 6px;
}
.mb-auto{
  margin-bottom: auto;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-3\\.5{
  margin-left: 0.875rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-\\[-32px\\]{
  margin-left: -32px;
}
.ml-\\[0\\.5px\\]{
  margin-left: 0.5px;
}
.ml-\\[24px\\]{
  margin-left: 24px;
}
.ml-\\[2px\\]{
  margin-left: 2px;
}
.ml-\\[394px\\]{
  margin-left: 394px;
}
.ml-\\[55px\\]{
  margin-left: 55px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-10{
  margin-right: 2.5rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-28{
  margin-right: 7rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-8{
  margin-right: 2rem;
}
.mr-9{
  margin-right: 2.25rem;
}
.mr-\\[-24px\\]{
  margin-right: -24px;
}
.mr-\\[2px\\]{
  margin-right: 2px;
}
.mr-\\[75px\\]{
  margin-right: 75px;
}
.mr-\\[7px\\]{
  margin-right: 7px;
}
.mr-\\[80px\\]{
  margin-right: 80px;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-11{
  margin-top: 2.75rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[10\\.5px\\]{
  margin-top: 10.5px;
}
.mt-\\[103px\\]{
  margin-top: 103px;
}
.mt-\\[10px\\]{
  margin-top: 10px;
}
.mt-\\[13\\%\\]{
  margin-top: 13%;
}
.mt-\\[2px\\]{
  margin-top: 2px;
}
.mt-\\[30px\\]{
  margin-top: 30px;
}
.mt-\\[31px\\]{
  margin-top: 31px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.\\!h-10{
  height: 2.5rem !important;
}
.\\!h-12{
  height: 3rem !important;
}
.\\!h-8{
  height: 2rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.\\!h-\\[115px\\]{
  height: 115px !important;
}
.\\!h-\\[36px\\]{
  height: 36px !important;
}
.\\!h-\\[40px\\]{
  height: 40px !important;
}
.\\!h-\\[52px\\]{
  height: 52px !important;
}
.\\!h-\\[calc\\(100vh-200px\\)\\]{
  height: calc(100vh - 200px) !important;
}
.\\!h-\\[calc\\(50vh-200px\\)\\]{
  height: calc(50vh - 200px) !important;
}
.\\!h-\\[calc\\(80vh-200px\\)\\]{
  height: calc(80vh - 200px) !important;
}
.\\!h-auto{
  height: auto !important;
}
.\\!h-fit{
  height: fit-content !important;
}
.h-1\\/4{
  height: 25%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[0\\.5px\\]{
  height: 0.5px;
}
.h-\\[0px\\]{
  height: 0px;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[1000px\\]{
  height: 1000px;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[11\\.67px\\]{
  height: 11.67px;
}
.h-\\[110px\\]{
  height: 110px;
}
.h-\\[117px\\]{
  height: 117px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[12px\\]{
  height: 12px;
}
.h-\\[13px\\]{
  height: 13px;
}
.h-\\[14px\\]{
  height: 14px;
}
.h-\\[154px\\]{
  height: 154px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[167px\\]{
  height: 167px;
}
.h-\\[17px\\]{
  height: 17px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[19\\.02px\\]{
  height: 19.02px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[219px\\]{
  height: 219px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[246px\\]{
  height: 246px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[27px\\]{
  height: 27px;
}
.h-\\[289px\\]{
  height: 289px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[31px\\]{
  height: 31px;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[35px\\]{
  height: 35px;
}
.h-\\[36px\\]{
  height: 36px;
}
.h-\\[37px\\]{
  height: 37px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[444px\\]{
  height: 444px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[45px\\]{
  height: 45px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[55px\\]{
  height: 55px;
}
.h-\\[563px\\]{
  height: 563px;
}
.h-\\[5px\\]{
  height: 5px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[63px\\]{
  height: 63px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-\\[6px\\]{
  height: 6px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[750px\\]{
  height: 750px;
}
.h-\\[77px\\]{
  height: 77px;
}
.h-\\[7px\\]{
  height: 7px;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[87\\%\\]{
  height: 87%;
}
.h-\\[89px\\]{
  height: 89px;
}
.h-\\[93vh\\]{
  height: 93vh;
}
.h-\\[95\\%\\]{
  height: 95%;
}
.h-\\[calc\\(100vh-220px\\)\\]{
  height: calc(100vh - 220px);
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-10{
  max-height: 2.5rem;
}
.max-h-12{
  max-height: 3rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[100px\\]{
  max-height: 100px;
}
.max-h-\\[130px\\]{
  max-height: 130px;
}
.max-h-\\[192px\\]{
  max-height: 192px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[250px\\]{
  max-height: 250px;
}
.max-h-\\[254px\\]{
  max-height: 254px;
}
.max-h-\\[292px\\]{
  max-height: 292px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[45\\%\\]{
  max-height: 45%;
}
.max-h-\\[450px\\]{
  max-height: 450px;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[50px\\]{
  max-height: 50px;
}
.max-h-\\[5px\\]{
  max-height: 5px;
}
.max-h-\\[600px\\]{
  max-height: 600px;
}
.max-h-\\[700px\\]{
  max-height: 700px;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[95\\%\\]{
  max-height: 95%;
}
.max-h-fit{
  max-height: fit-content;
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-4{
  min-height: 1rem;
}
.min-h-52{
  min-height: 13rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[115px\\]{
  min-height: 115px;
}
.min-h-\\[14px\\]{
  min-height: 14px;
}
.min-h-\\[150px\\]{
  min-height: 150px;
}
.min-h-\\[16px\\]{
  min-height: 16px;
}
.min-h-\\[18px\\]{
  min-height: 18px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[24px\\]{
  min-height: 24px;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[46px\\]{
  min-height: 46px;
}
.min-h-\\[4px\\]{
  min-height: 4px;
}
.min-h-\\[52px\\]{
  min-height: 52px;
}
.min-h-\\[5px\\]{
  min-height: 5px;
}
.min-h-\\[600px\\]{
  min-height: 600px;
}
.min-h-\\[63px\\]{
  min-height: 63px;
}
.min-h-\\[660px\\]{
  min-height: 660px;
}
.min-h-\\[68px\\]{
  min-height: 68px;
}
.min-h-\\[73px\\]{
  min-height: 73px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-24{
  width: 6rem !important;
}
.\\!w-\\[115px\\]{
  width: 115px !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-4\\/6{
  width: 66.666667%;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[10\\.69\\%\\]{
  width: 10.69%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[102\\%\\]{
  width: 102%;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[121px\\]{
  width: 121px;
}
.w-\\[12px\\]{
  width: 12px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[131px\\]{
  width: 131px;
}
.w-\\[137px\\]{
  width: 137px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[17\\.6\\%\\]{
  width: 17.6%;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[172px\\]{
  width: 172px;
}
.w-\\[18\\.33px\\]{
  width: 18.33px;
}
.w-\\[18\\.69\\%\\]{
  width: 18.69%;
}
.w-\\[18\\.8\\%\\]{
  width: 18.8%;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[181px\\]{
  width: 181px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[19\\%\\]{
  width: 19%;
}
.w-\\[19\\.02px\\]{
  width: 19.02px;
}
.w-\\[192px\\]{
  width: 192px;
}
.w-\\[195px\\]{
  width: 195px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[2\\%\\]{
  width: 2%;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[21\\.59\\%\\]{
  width: 21.59%;
}
.w-\\[212px\\]{
  width: 212px;
}
.w-\\[214px\\]{
  width: 214px;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[22\\.42\\%\\]{
  width: 22.42%;
}
.w-\\[22\\.9\\%\\]{
  width: 22.9%;
}
.w-\\[229px\\]{
  width: 229px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[23\\%\\]{
  width: 23%;
}
.w-\\[23\\.58\\%\\]{
  width: 23.58%;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[24\\.9\\%\\]{
  width: 24.9%;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[242px\\]{
  width: 242px;
}
.w-\\[246px\\]{
  width: 246px;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[25\\.9\\%\\]{
  width: 25.9%;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[259px\\]{
  width: 259px;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[263px\\]{
  width: 263px;
}
.w-\\[27\\%\\]{
  width: 27%;
}
.w-\\[270px\\]{
  width: 270px;
}
.w-\\[277px\\]{
  width: 277px;
}
.w-\\[28\\%\\]{
  width: 28%;
}
.w-\\[28\\.07\\%\\]{
  width: 28.07%;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[29\\.47px\\]{
  width: 29.47px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[332px\\]{
  width: 332px;
}
.w-\\[34px\\]{
  width: 34px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[35px\\]{
  width: 35px;
}
.w-\\[362px\\]{
  width: 362px;
}
.w-\\[367px\\]{
  width: 367px;
}
.w-\\[37\\%\\]{
  width: 37%;
}
.w-\\[38px\\]{
  width: 38px;
}
.w-\\[39\\.9\\%\\]{
  width: 39.9%;
}
.w-\\[394px\\]{
  width: 394px;
}
.w-\\[39px\\]{
  width: 39px;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[4\\.31\\%\\]{
  width: 4.31%;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[470px\\]{
  width: 470px;
}
.w-\\[48\\%\\]{
  width: 48%;
}
.w-\\[49\\%\\]{
  width: 49%;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[5\\.6\\%\\]{
  width: 5.6%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[55\\.6\\%\\]{
  width: 55.6%;
}
.w-\\[5px\\]{
  width: 5px;
}
.w-\\[63px\\]{
  width: 63px;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[6px\\]{
  width: 6px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[75\\%\\]{
  width: 75%;
}
.w-\\[7px\\]{
  width: 7px;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[83\\.5\\%\\]{
  width: 83.5%;
}
.w-\\[86\\%\\]{
  width: 86%;
}
.w-\\[87\\%\\]{
  width: 87%;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[89px\\]{
  width: 89px;
}
.w-\\[9\\.1\\%\\]{
  width: 9.1%;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[97\\%\\]{
  width: 97%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.min-w-4{
  min-width: 1rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[115px\\]{
  min-width: 115px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[134px\\]{
  min-width: 134px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[14px\\]{
  min-width: 14px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[175px\\]{
  min-width: 175px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[183px\\]{
  min-width: 183px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[214px\\]{
  min-width: 214px;
}
.min-w-\\[24px\\]{
  min-width: 24px;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[314px\\]{
  min-width: 314px;
}
.min-w-\\[46px\\]{
  min-width: 46px;
}
.min-w-\\[4px\\]{
  min-width: 4px;
}
.min-w-\\[50px\\]{
  min-width: 50px;
}
.min-w-\\[5px\\]{
  min-width: 5px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[63px\\]{
  min-width: 63px;
}
.min-w-\\[68px\\]{
  min-width: 68px;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-72{
  max-width: 18rem;
}
.max-w-\\[100\\%\\]{
  max-width: 100%;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[130px\\]{
  max-width: 130px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[162px\\]{
  max-width: 162px;
}
.max-w-\\[179px\\]{
  max-width: 179px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[182px\\]{
  max-width: 182px;
}
.max-w-\\[187px\\]{
  max-width: 187px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[203px\\]{
  max-width: 203px;
}
.max-w-\\[206px\\]{
  max-width: 206px;
}
.max-w-\\[226px\\]{
  max-width: 226px;
}
.max-w-\\[238px\\]{
  max-width: 238px;
}
.max-w-\\[242px\\]{
  max-width: 242px;
}
.max-w-\\[245px\\]{
  max-width: 245px;
}
.max-w-\\[250px\\]{
  max-width: 250px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[266px\\]{
  max-width: 266px;
}
.max-w-\\[270px\\]{
  max-width: 270px;
}
.max-w-\\[275px\\]{
  max-width: 275px;
}
.max-w-\\[276px\\]{
  max-width: 276px;
}
.max-w-\\[278px\\]{
  max-width: 278px;
}
.max-w-\\[286px\\]{
  max-width: 286px;
}
.max-w-\\[288px\\]{
  max-width: 288px;
}
.max-w-\\[289px\\]{
  max-width: 289px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[304px\\]{
  max-width: 304px;
}
.max-w-\\[30px\\]{
  max-width: 30px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[326px\\]{
  max-width: 326px;
}
.max-w-\\[335px\\]{
  max-width: 335px;
}
.max-w-\\[339px\\]{
  max-width: 339px;
}
.max-w-\\[350px\\]{
  max-width: 350px;
}
.max-w-\\[351px\\]{
  max-width: 351px;
}
.max-w-\\[352px\\]{
  max-width: 352px;
}
.max-w-\\[355px\\]{
  max-width: 355px;
}
.max-w-\\[357px\\]{
  max-width: 357px;
}
.max-w-\\[365px\\]{
  max-width: 365px;
}
.max-w-\\[369px\\]{
  max-width: 369px;
}
.max-w-\\[376px\\]{
  max-width: 376px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[385px\\]{
  max-width: 385px;
}
.max-w-\\[394px\\]{
  max-width: 394px;
}
.max-w-\\[395px\\]{
  max-width: 395px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[426px\\]{
  max-width: 426px;
}
.max-w-\\[439px\\]{
  max-width: 439px;
}
.max-w-\\[443px\\]{
  max-width: 443px;
}
.max-w-\\[444px\\]{
  max-width: 444px;
}
.max-w-\\[448px\\]{
  max-width: 448px;
}
.max-w-\\[450px\\]{
  max-width: 450px;
}
.max-w-\\[455px\\]{
  max-width: 455px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[488px\\]{
  max-width: 488px;
}
.max-w-\\[48px\\]{
  max-width: 48px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[512px\\]{
  max-width: 512px;
}
.max-w-\\[516px\\]{
  max-width: 516px;
}
.max-w-\\[528px\\]{
  max-width: 528px;
}
.max-w-\\[544px\\]{
  max-width: 544px;
}
.max-w-\\[579px\\]{
  max-width: 579px;
}
.max-w-\\[580px\\]{
  max-width: 580px;
}
.max-w-\\[581px\\]{
  max-width: 581px;
}
.max-w-\\[600px\\]{
  max-width: 600px;
}
.max-w-\\[641px\\]{
  max-width: 641px;
}
.max-w-\\[728px\\]{
  max-width: 728px;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[90px\\]{
  max-width: 90px;
}
.max-w-\\[98\\%\\]{
  max-width: 98%;
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.basis-1\\/2{
  flex-basis: 50%;
}
.basis-\\[17\\.14\\%\\]{
  flex-basis: 17.14%;
}
.basis-\\[17\\.58\\%\\]{
  flex-basis: 17.58%;
}
.basis-\\[21\\.14\\%\\]{
  flex-basis: 21.14%;
}
.basis-\\[30\\.709\\%\\]{
  flex-basis: 30.709%;
}
.basis-\\[65\\.571\\%\\]{
  flex-basis: 65.571%;
}
.basis-\\[67\\.2\\%\\]{
  flex-basis: 67.2%;
}
.basis-full{
  flex-basis: 100%;
}
.table-auto{
  table-layout: auto;
}
.origin-top{
  transform-origin: top;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-40{
  --tw-translate-x: -10rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2{
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\.5{
  --tw-translate-x: 0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3{
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[17px\\]{
  --tw-translate-x: 17px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[2\\.5px\\]{
  --tw-translate-x: 2.5px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-20{
  --tw-translate-y: 5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-180{
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-\\[130deg\\]{
  --tw-rotate: -130deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[270deg\\]{
  --tw-rotate: 270deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-0{
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-100{
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes visible{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 100;
  }
}
.animate-dropdown{
  animation: visible 300ms ease-out;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes shimmer{

  0%{
    transform: translateX(-100%);
  }

  100%{
    transform: translateX(100%);
  }
}
.animate-shimmer{
  animation: shimmer 1.5s infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-outside{
  list-style-position: outside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[40\\%_40\\%_20\\%\\]{
  grid-template-columns: 40% 40% 20%;
}
.grid-cols-\\[55\\%_40\\%\\]{
  grid-template-columns: 55% 40%;
}
.grid-cols-\\[auto_auto\\]{
  grid-template-columns: auto auto;
}
.grid-cols-\\[auto_auto_auto_auto\\]{
  grid-template-columns: auto auto auto auto;
}
.grid-rows-\\[2rem\\]{
  grid-template-rows: 2rem;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.\\!items-start{
  align-items: flex-start !important;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-normal{
  justify-content: normal;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-14{
  gap: 3.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[137px\\]{
  gap: 137px;
}
.gap-\\[15px\\]{
  gap: 15px;
}
.gap-\\[18px\\]{
  gap: 18px;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[3\\.72\\%\\]{
  gap: 3.72%;
}
.gap-\\[30px\\]{
  gap: 30px;
}
.gap-\\[37px\\]{
  gap: 37px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[54px\\]{
  gap: 54px;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[85px\\]{
  gap: 85px;
}
.gap-\\[90px\\]{
  gap: 90px;
}
.gap-\\[95px\\]{
  gap: 95px;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-11{
  row-gap: 2.75rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.gap-y-\\[2px\\]{
  row-gap: 2px;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-\\[6px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-6px * var(--tw-space-x-reverse));
  margin-left: calc(-6px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-clip{
  overflow: clip;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.text-wrap{
  text-wrap: wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded-\\[4px\\]{
  border-radius: 4px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[30px\\]{
  border-radius: 30px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-\\[10px\\]{
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-none{
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[0\\.5px\\]{
  border-width: 0.5px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[0\\.5px\\]{
  border-bottom-width: 0.5px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[0\\.5px\\]{
  border-top-width: 0.5px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.\\!border-\\[\\#dfe4eb\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(223 228 235 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#000000\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#12376914\\]{
  border-color: #12376914;
}
.border-\\[\\#12376940\\]{
  border-color: #12376940;
}
.border-\\[\\#198b7b\\]{
  --tw-border-opacity: 1;
  border-color: rgb(25 139 123 / var(--tw-border-opacity, 1));
}
.border-\\[\\#333442\\]{
  --tw-border-opacity: 1;
  border-color: rgb(51 52 66 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3F7CDB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(63 124 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4F7FD1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(79 127 209 / var(--tw-border-opacity, 1));
}
.border-\\[\\#667185\\]{
  --tw-border-opacity: 1;
  border-color: rgb(102 113 133 / var(--tw-border-opacity, 1));
}
.border-\\[\\#858DAA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(133 141 170 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8D8D91\\]{
  --tw-border-opacity: 1;
  border-color: rgb(141 141 145 / var(--tw-border-opacity, 1));
}
.border-\\[\\#96a9c3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(150 169 195 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9FBDED\\]{
  --tw-border-opacity: 1;
  border-color: rgb(159 189 237 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BFD3F3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(191 211 243 / var(--tw-border-opacity, 1));
}
.border-\\[\\#CECED2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-\\[\\#CED2DD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(206 210 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D4D4D8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9E5F8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 229 248 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DFE1E7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(223 225 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E1E4EA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(225 228 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E3E6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 227 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E3EC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 227 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E4E6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E4E7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E6E6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 230 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E7EC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E6E7EB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(230 231 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EAECF0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(234 236 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EBEBEB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ECECEC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(236 236 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EEF3FC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(238 243 252 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFEFEF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFF2F5\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 242 245 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0F0F0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 240 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0FFFE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 255 254 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F2F4F7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(242 244 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F3F3F4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(243 243 244 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F3F4F7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F4DCDD\\]{
  --tw-border-opacity: 1;
  border-color: rgb(244 220 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F6F7F9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(246 247 249 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F7F7F7\\]{
  --tw-border-opacity: 1;
  border-color: rgb(247 247 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F7F9FC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(247 249 252 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F9F9F9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(249 249 249 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cccccc\\]{
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7dde4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(215 221 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe1e9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(219 225 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce1e9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(220 225 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dce2e9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(220 226 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e1e1e3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(225 225 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e1e4ea\\]{
  --tw-border-opacity: 1;
  border-color: rgb(225 228 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e4e3ec\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 227 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ececec\\]{
  --tw-border-opacity: 1;
  border-color: rgb(236 236 236 / var(--tw-border-opacity, 1));
}
.border-\\[var\\(--color-primary\\)\\]{
  border-color: var(--color-primary);
}
.border-batchBlue20{
  --tw-border-opacity: 1;
  border-color: rgb(217 229 248 / var(--tw-border-opacity, 1));
}
.border-black25{
  --tw-border-opacity: 1;
  border-color: rgb(187 187 187 / var(--tw-border-opacity, 1));
}
.border-body{
  --tw-border-opacity: 1;
  border-color: rgb(92 104 142 / var(--tw-border-opacity, 1));
}
.border-brandBlue{
  border-color: var(--color-primary);
}
.border-brandBlue20{
  --tw-border-opacity: 1;
  border-color: rgb(159 190 237 / var(--tw-border-opacity, 1));
}
.border-brandBlue4{
  --tw-border-opacity: 1;
  border-color: rgb(217 229 248 / var(--tw-border-opacity, 1));
}
.border-brandBlue60{
  --tw-border-opacity: 1;
  border-color: rgb(159 189 237 / var(--tw-border-opacity, 1));
}
.border-brandBlue80{
  --tw-border-opacity: 1;
  border-color: rgb(95 146 225 / var(--tw-border-opacity, 1));
}
.border-danger{
  --tw-border-opacity: 1;
  border-color: rgb(241 93 95 / var(--tw-border-opacity, 1));
}
.border-dojahBlue{
  --tw-border-opacity: 1;
  border-color: rgb(63 124 219 / var(--tw-border-opacity, 1));
}
.border-grey-100{
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity, 1));
}
.border-grey-50{
  --tw-border-opacity: 1;
  border-color: rgb(243 243 243 / var(--tw-border-opacity, 1));
}
.border-grey-500{
  --tw-border-opacity: 1;
  border-color: rgb(134 134 134 / var(--tw-border-opacity, 1));
}
.border-grey20{
  --tw-border-opacity: 1;
  border-color: rgb(142 144 169 / var(--tw-border-opacity, 1));
}
.border-grey30{
  --tw-border-opacity: 1;
  border-color: rgb(133 133 142 / var(--tw-border-opacity, 1));
}
.border-grey4{
  border-color: rgba(242,242,248,0.75);
}
.border-grey5{
  --tw-border-opacity: 1;
  border-color: rgb(199 199 199 / var(--tw-border-opacity, 1));
}
.border-grey60{
  --tw-border-opacity: 1;
  border-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-status-200{
  --tw-border-opacity: 1;
  border-color: rgb(74 135 141 / var(--tw-border-opacity, 1));
}
.border-status-404{
  --tw-border-opacity: 1;
  border-color: rgb(161 62 63 / var(--tw-border-opacity, 1));
}
.border-success{
  --tw-border-opacity: 1;
  border-color: rgb(74 135 141 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white80{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity, 1));
}
.border-x-\\[\\#E0E4EB\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(224 228 235 / var(--tw-border-opacity, 1));
  border-right-color: rgb(224 228 235 / var(--tw-border-opacity, 1));
}
.border-x-transparent{
  border-left-color: transparent;
  border-right-color: transparent;
}
.border-y-\\[\\#CECED2\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-y-\\[\\#E4E3EC\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(228 227 236 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(228 227 236 / var(--tw-border-opacity, 1));
}
.border-y-\\[\\#EFEFEF\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}
.border-y-\\[\\#ececec\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(236 236 236 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(236 236 236 / var(--tw-border-opacity, 1));
}
.border-y-grey60{
  --tw-border-opacity: 1;
  border-top-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#E1E4EA\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(225 228 234 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#E4E3E6\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(228 227 230 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#E4E3EC\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(228 227 236 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#E4E4E6\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(228 228 230 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#EFEFEF\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#F6F7F9\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(246 247 249 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#ceced2\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#e9e9e9\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(233 233 233 / var(--tw-border-opacity, 1));
}
.border-b-black25{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(187 187 187 / var(--tw-border-opacity, 1));
}
.border-b-success{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(74 135 141 / var(--tw-border-opacity, 1));
}
.border-b-white{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-b-white80{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(250 250 250 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#F2F2F2\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(242 242 242 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#E6E7EB\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(230 231 235 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#EAECF0\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(234 236 240 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#EFEFEF\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#F2F2F2\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(242 242 242 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#f2f2f2\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(242 242 242 / var(--tw-border-opacity, 1));
}
.border-t-grey5{
  --tw-border-opacity: 1;
  border-top-color: rgb(199 199 199 / var(--tw-border-opacity, 1));
}
.border-t-grey60{
  --tw-border-opacity: 1;
  border-top-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-opacity-0{
  --tw-border-opacity: 0;
}
.\\!bg-\\[\\#963134\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(150 49 52 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#B42318\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-brandBlue{
  background-color: var(--color-primary) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white80{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#006464\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 100 100 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#010080\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(1 0 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B1C56\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 28 86 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F0F19\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 25 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161b40\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 27 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#17A6A0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(23 166 160 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c1d31\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 49 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#242424\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(36 36 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2A5392\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 83 146 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#34C759\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(52 199 89 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#391169\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(57 17 105 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3F7CDB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(63 124 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4A4A68\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(74 74 104 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4A878D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(74 135 141 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#55A249\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(85 162 73 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#561269\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(86 18 105 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6496e3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(100 150 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6507082B\\]{
  background-color: #6507082B;
}
.bg-\\[\\#71B167\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(113 177 103 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7459D91A\\]{
  background-color: #7459D91A;
}
.bg-\\[\\#767676\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(118 118 118 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#963134\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(150 49 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#A13E3F2B\\]{
  background-color: #A13E3F2B;
}
.bg-\\[\\#B42318\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#BB371A12\\]{
  background-color: #BB371A12;
}
.bg-\\[\\#BFD3F3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(191 211 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C0483F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(192 72 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C83737\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(200 55 55 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D2D2D2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(210 210 210 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D5D5D5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(213 213 213 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9E5F8B2\\]{
  background-color: #D9E5F8B2;
}
.bg-\\[\\#D9E5F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 229 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DAE4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(218 228 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DC6803\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DDECDB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(221 236 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DEDEE3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(222 222 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E1E4EA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(225 228 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E2F5F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 245 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E6E6E6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E77E03\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 126 3 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E9EBF0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 235 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EB001B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 0 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBF1FC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 241 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECECEC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDEDED\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EEF3FC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0D3D1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 211 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F6EF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0FFFE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 255 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F6FD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F6FE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F3F3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3FCF1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 252 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F6F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F6F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F6FB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F7F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F9F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F9FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 249 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F79E1B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 158 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F7F7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8EBEA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 235 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F9FB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9FAFB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBF4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 244 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCDFDF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 223 223 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCF6F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 246 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF3F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF681C2B\\]{
  background-color: #FF681C2B;
}
.bg-\\[\\#FFD9512B\\]{
  background-color: #FFD9512B;
}
.bg-\\[\\#FFF0F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF8EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFAF0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c8d3dc90\\]\\/10{
  background-color: rgb(200 211 220 / 0.1);
}
.bg-\\[\\#e1e4ea\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(225 228 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e3e3e3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(227 227 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e5e7eb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef3fc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#efeff0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f1f1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2e6f7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 230 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f7f7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f9f9f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fefefe\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--color-primary\\)\\]{
  background-color: var(--color-primary);
}
.bg-accent-100{
  --tw-bg-opacity: 1;
  background-color: rgb(206 224 226 / var(--tw-bg-opacity, 1));
}
.bg-batchBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(42 83 146 / var(--tw-bg-opacity, 1));
}
.bg-batchBlue20{
  --tw-bg-opacity: 1;
  background-color: rgb(217 229 248 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black25{
  --tw-bg-opacity: 1;
  background-color: rgb(187 187 187 / var(--tw-bg-opacity, 1));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 220 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 243 255 / var(--tw-bg-opacity, 1));
}
.bg-body{
  --tw-bg-opacity: 1;
  background-color: rgb(92 104 142 / var(--tw-bg-opacity, 1));
}
.bg-brandBlue{
  background-color: var(--color-primary);
}
.bg-brandBlue20{
  --tw-bg-opacity: 1;
  background-color: rgb(159 190 237 / var(--tw-bg-opacity, 1));
}
.bg-brandBlue4{
  --tw-bg-opacity: 1;
  background-color: rgb(217 229 248 / var(--tw-bg-opacity, 1));
}
.bg-brandBlue40{
  --tw-bg-opacity: 1;
  background-color: rgb(217 229 248 / var(--tw-bg-opacity, 1));
}
.bg-brandBlue50{
  --tw-bg-opacity: 1;
  background-color: rgb(42 83 146 / var(--tw-bg-opacity, 1));
}
.bg-brandBlue60{
  --tw-bg-opacity: 1;
  background-color: rgb(159 189 237 / var(--tw-bg-opacity, 1));
}
.bg-brandBlueLight{
  --tw-bg-opacity: 1;
  background-color: rgb(234 240 248 / var(--tw-bg-opacity, 1));
}
.bg-danger{
  --tw-bg-opacity: 1;
  background-color: rgb(241 93 95 / var(--tw-bg-opacity, 1));
}
.bg-deepBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(11 28 86 / var(--tw-bg-opacity, 1));
}
.bg-disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(210 210 211 / var(--tw-bg-opacity, 1));
}
.bg-dojahBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(63 124 219 / var(--tw-bg-opacity, 1));
}
.bg-error{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(0 112 108 / var(--tw-bg-opacity, 1));
}
.bg-grey{
  --tw-bg-opacity: 1;
  background-color: rgb(8 9 23 / var(--tw-bg-opacity, 1));
}
.bg-grey-100{
  --tw-bg-opacity: 1;
  background-color: rgb(221 221 221 / var(--tw-bg-opacity, 1));
}
.bg-grey-50{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));
}
.bg-grey-500{
  --tw-bg-opacity: 1;
  background-color: rgb(134 134 134 / var(--tw-bg-opacity, 1));
}
.bg-grey30{
  --tw-bg-opacity: 1;
  background-color: rgb(133 133 142 / var(--tw-bg-opacity, 1));
}
.bg-grey4{
  background-color: rgba(242,242,248,0.75);
}
.bg-grey5{
  --tw-bg-opacity: 1;
  background-color: rgb(199 199 199 / var(--tw-bg-opacity, 1));
}
.bg-grey60{
  --tw-bg-opacity: 1;
  background-color: rgb(206 206 210 / var(--tw-bg-opacity, 1));
}
.bg-grey90{
  --tw-bg-opacity: 1;
  background-color: rgb(133 141 170 / var(--tw-bg-opacity, 1));
}
.bg-pending20{
  background-color: #FFD9512B;
}
.bg-red{
  --tw-bg-opacity: 1;
  background-color: rgb(243 120 122 / var(--tw-bg-opacity, 1));
}
.bg-red-800{
  --tw-bg-opacity: 1;
  background-color: rgb(151 17 34 / var(--tw-bg-opacity, 1));
}
.bg-secondaryBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(30 34 84 / var(--tw-bg-opacity, 1));
}
.bg-sidebarBlue{
  --tw-bg-opacity: 1;
  background-color: rgb(9 11 26 / var(--tw-bg-opacity, 1));
}
.bg-status-400{
  --tw-bg-opacity: 1;
  background-color: rgb(20 23 56 / var(--tw-bg-opacity, 1));
}
.bg-status-404{
  --tw-bg-opacity: 1;
  background-color: rgb(161 62 63 / var(--tw-bg-opacity, 1));
}
.bg-status-500{
  --tw-bg-opacity: 1;
  background-color: rgb(161 62 63 / var(--tw-bg-opacity, 1));
}
.bg-statusBg-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 245 246 / var(--tw-bg-opacity, 1));
}
.bg-statusBg-400{
  --tw-bg-opacity: 1;
  background-color: rgb(210 211 221 / var(--tw-bg-opacity, 1));
}
.bg-statusBg-404{
  --tw-bg-opacity: 1;
  background-color: rgb(252 223 223 / var(--tw-bg-opacity, 1));
}
.bg-statusBg-500{
  --tw-bg-opacity: 1;
  background-color: rgb(252 223 223 / var(--tw-bg-opacity, 1));
}
.bg-success{
  --tw-bg-opacity: 1;
  background-color: rgb(74 135 141 / var(--tw-bg-opacity, 1));
}
.bg-success20{
  --tw-bg-opacity: 1;
  background-color: rgb(226 245 246 / var(--tw-bg-opacity, 1));
}
.bg-success80{
  --tw-bg-opacity: 1;
  background-color: rgb(111 203 212 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-warning{
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity, 1));
}
.bg-warning20{
  --tw-bg-opacity: 1;
  background-color: rgb(253 189 71 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white80{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-opacity-25{
  --tw-bg-opacity: 0.25;
}
.bg-opacity-30{
  --tw-bg-opacity: 0.3;
}
.bg-opacity-70{
  --tw-bg-opacity: 0.7;
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-black{
  fill: #000;
}
.stroke-none{
  stroke: none;
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-2{
  padding: 0.5rem !important;
}
.\\!p-6{
  padding: 1.5rem !important;
}
.\\!p-\\[48px\\]{
  padding: 48px !important;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-\\[35px\\]{
  padding: 35px;
}
.p-\\[4px\\]{
  padding: 4px;
}
.p-\\[5px\\]{
  padding: 5px;
}
.\\!px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.\\!py-10{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.\\!py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.\\!py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.\\!py-\\[11px\\]{
  padding-top: 11px !important;
  padding-bottom: 11px !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-32{
  padding-left: 8rem;
  padding-right: 8rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[14px\\]{
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[19px\\]{
  padding-left: 19px;
  padding-right: 19px;
}
.px-\\[1px\\]{
  padding-left: 1px;
  padding-right: 1px;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[27px\\]{
  padding-left: 27px;
  padding-right: 27px;
}
.px-\\[35px\\]{
  padding-left: 35px;
  padding-right: 35px;
}
.px-\\[40px\\]{
  padding-left: 40px;
  padding-right: 40px;
}
.px-\\[44px\\]{
  padding-left: 44px;
  padding-right: 44px;
}
.px-\\[47px\\]{
  padding-left: 47px;
  padding-right: 47px;
}
.px-\\[5\\.5px\\]{
  padding-left: 5.5px;
  padding-right: 5.5px;
}
.px-\\[5\\.88\\%\\]{
  padding-left: 5.88%;
  padding-right: 5.88%;
}
.px-\\[5px\\]{
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[81px\\]{
  padding-left: 81px;
  padding-right: 81px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.px-\\[95px\\]{
  padding-left: 95px;
  padding-right: 95px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9{
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[14px\\]{
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[19px\\]{
  padding-top: 19px;
  padding-bottom: 19px;
}
.py-\\[22px\\]{
  padding-top: 22px;
  padding-bottom: 22px;
}
.py-\\[2px\\]{
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[70px\\]{
  padding-top: 70px;
  padding-bottom: 70px;
}
.py-\\[9px\\]{
  padding-top: 9px;
  padding-bottom: 9px;
}
.\\!pl-0{
  padding-left: 0px !important;
}
.\\!pr-0{
  padding-right: 0px !important;
}
.\\!pr-6{
  padding-right: 1.5rem !important;
}
.\\!pt-0{
  padding-top: 0px !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-9{
  padding-bottom: 2.25rem;
}
.pb-\\[10px\\]{
  padding-bottom: 10px;
}
.pb-\\[11px\\]{
  padding-bottom: 11px;
}
.pb-\\[14px\\]{
  padding-bottom: 14px;
}
.pb-\\[20vh\\]{
  padding-bottom: 20vh;
}
.pb-\\[2px\\]{
  padding-bottom: 2px;
}
.pb-\\[36vh\\]{
  padding-bottom: 36vh;
}
.pb-\\[3px\\]{
  padding-bottom: 3px;
}
.pb-\\[4px\\]{
  padding-bottom: 4px;
}
.pb-\\[5px\\]{
  padding-bottom: 5px;
}
.pb-\\[6px\\]{
  padding-bottom: 6px;
}
.pb-\\[7px\\]{
  padding-bottom: 7px;
}
.pb-\\[8px\\]{
  padding-bottom: 8px;
}
.pb-\\[9px\\]{
  padding-bottom: 9px;
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[19\\.72\\%\\]{
  padding-left: 19.72%;
}
.pl-\\[38px\\]{
  padding-left: 38px;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-11{
  padding-right: 2.75rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-20{
  padding-right: 5rem;
}
.pr-22{
  padding-right: 5.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pr-\\[150px\\]{
  padding-right: 150px;
}
.pr-\\[226px\\]{
  padding-right: 226px;
}
.pr-\\[76px\\]{
  padding-right: 76px;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-11{
  padding-top: 2.75rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-22{
  padding-top: 5.5rem;
}
.pt-28{
  padding-top: 7rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-40{
  padding-top: 10rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[102px\\]{
  padding-top: 102px;
}
.pt-\\[108px\\]{
  padding-top: 108px;
}
.pt-\\[10px\\]{
  padding-top: 10px;
}
.pt-\\[140px\\]{
  padding-top: 140px;
}
.pt-\\[14px\\]{
  padding-top: 14px;
}
.pt-\\[180px\\]{
  padding-top: 180px;
}
.pt-\\[18px\\]{
  padding-top: 18px;
}
.pt-\\[200px\\]{
  padding-top: 200px;
}
.pt-\\[220px\\]{
  padding-top: 220px;
}
.pt-\\[240px\\]{
  padding-top: 240px;
}
.pt-\\[26px\\]{
  padding-top: 26px;
}
.pt-\\[2px\\]{
  padding-top: 2px;
}
.pt-\\[31px\\]{
  padding-top: 31px;
}
.pt-\\[3px\\]{
  padding-top: 3px;
}
.pt-\\[4px\\]{
  padding-top: 4px;
}
.pt-\\[5px\\]{
  padding-top: 5px;
}
.pt-\\[6px\\]{
  padding-top: 6px;
}
.pt-\\[72px\\]{
  padding-top: 72px;
}
.pt-\\[7px\\]{
  padding-top: 7px;
}
.pt-\\[8px\\]{
  padding-top: 8px;
}
.pt-\\[9px\\]{
  padding-top: 9px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.font-inter{
  font-family: Inter, sans-serif;
}
.font-sans{
  font-family: "Mona Sans", sans-serif;
}
.\\!text-\\[10px\\]{
  font-size: 10px !important;
}
.\\!text-\\[12px\\]{
  font-size: 12px !important;
}
.\\!text-\\[24px\\]{
  font-size: 24px !important;
}
.\\!text-sm{
  font-size: .8125rem !important;
  line-height: 18px !important;
}
.\\!text-small{
  font-size: .75rem !important;
  line-height: 17.38px !important;
}
.\\!text-xs{
  font-size: .625rem !important;
  line-height: 12px !important;
}
.text-\\[0\\.55vw\\]{
  font-size: 0.55vw;
}
.text-\\[0\\.75rem\\]{
  font-size: 0.75rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[0\\.9rem\\]{
  font-size: 0.9rem;
}
.text-\\[1\\.1rem\\]{
  font-size: 1.1rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[29px\\]{
  font-size: 29px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[36px\\]{
  font-size: 36px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-\\[64px\\]{
  font-size: 64px;
}
.text-\\[6px\\]{
  font-size: 6px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 24px;
}
.text-lg{
  font-size: 1.25rem;
  line-height: 28px;
}
.text-md{
  font-size: 1.5rem;
}
.text-sm{
  font-size: .8125rem;
  line-height: 18px;
}
.text-small{
  font-size: .75rem;
  line-height: 17.38px;
}
.text-tiny{
  font-size: .875rem;
}
.text-xl{
  font-size: 1.5625rem;
  line-height: 30px;
}
.text-xs{
  font-size: .625rem;
  line-height: 12px;
}
.text-xxl{
  font-size: 1.9375rem;
}
.text-xxxl{
  font-size: 2.5rem;
  line-height: 48px;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.font-thin{
  font-weight: 100;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-3{
  line-height: .75rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-\\[12px\\]{
  line-height: 12px;
}
.leading-\\[14px\\]{
  line-height: 14px;
}
.leading-\\[16px\\]{
  line-height: 16px;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.leading-\\[21\\.9px\\]{
  line-height: 21.9px;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.tracking-\\[-0\\.01em\\]{
  letter-spacing: -0.01em;
}
.tracking-\\[-0\\.02em\\]{
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.5px\\]{
  letter-spacing: -0.5px;
}
.tracking-\\[-1\\%\\]{
  letter-spacing: -1%;
}
.tracking-\\[0\\.04em\\]{
  letter-spacing: 0.04em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#033971\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(3 57 113 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#B42318\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#033971\\]{
  --tw-text-opacity: 1;
  color: rgb(3 57 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#080917\\]{
  --tw-text-opacity: 1;
  color: rgb(8 9 23 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0B1C56\\]{
  --tw-text-opacity: 1;
  color: rgb(11 28 86 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0D192C\\]{
  --tw-text-opacity: 1;
  color: rgb(13 25 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#101828\\]{
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#127D78\\]{
  --tw-text-opacity: 1;
  color: rgb(18 125 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#141738\\]{
  --tw-text-opacity: 1;
  color: rgb(20 23 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#17A6A0\\]{
  --tw-text-opacity: 1;
  color: rgb(23 166 160 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18181B\\]{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A1A21\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 33 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B2A4E\\]{
  --tw-text-opacity: 1;
  color: rgb(27 42 78 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D1D1D\\]{
  --tw-text-opacity: 1;
  color: rgb(29 29 29 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D1F26\\]{
  --tw-text-opacity: 1;
  color: rgb(29 31 38 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D2739\\]{
  --tw-text-opacity: 1;
  color: rgb(29 39 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1E2254\\]{
  --tw-text-opacity: 1;
  color: rgb(30 34 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#242424\\]{
  --tw-text-opacity: 1;
  color: rgb(36 36 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#252430\\]{
  --tw-text-opacity: 1;
  color: rgb(37 36 48 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2A5392\\]{
  --tw-text-opacity: 1;
  color: rgb(42 83 146 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344054\\]{
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344272\\]{
  --tw-text-opacity: 1;
  color: rgb(52 66 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3567B6\\]{
  --tw-text-opacity: 1;
  color: rgb(53 103 182 / var(--tw-text-opacity, 1));
}
.text-\\[\\#396C31\\]{
  --tw-text-opacity: 1;
  color: rgb(57 108 49 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B4454\\]{
  --tw-text-opacity: 1;
  color: rgb(59 68 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3F7CDB\\]{
  --tw-text-opacity: 1;
  color: rgb(63 124 219 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3FB12C\\]{
  --tw-text-opacity: 1;
  color: rgb(63 177 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3c4978\\]{
  --tw-text-opacity: 1;
  color: rgb(60 73 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#444444\\]{
  --tw-text-opacity: 1;
  color: rgb(68 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#464646\\]{
  --tw-text-opacity: 1;
  color: rgb(70 70 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A4A68\\]{
  --tw-text-opacity: 1;
  color: rgb(74 74 104 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A878D\\]{
  --tw-text-opacity: 1;
  color: rgb(74 135 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4E4E4E\\]{
  --tw-text-opacity: 1;
  color: rgb(78 78 78 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4F555F\\]{
  --tw-text-opacity: 1;
  color: rgb(79 85 95 / var(--tw-text-opacity, 1));
}
.text-\\[\\#555555\\]{
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#55A249\\]{
  --tw-text-opacity: 1;
  color: rgb(85 162 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5B687B\\]{
  --tw-text-opacity: 1;
  color: rgb(91 104 123 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5C688E\\]{
  --tw-text-opacity: 1;
  color: rgb(92 104 142 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5E3EEB\\]{
  --tw-text-opacity: 1;
  color: rgb(94 62 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5E5E5E\\]{
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#650708\\]{
  --tw-text-opacity: 1;
  color: rgb(101 7 8 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667085\\]{
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667185\\]{
  --tw-text-opacity: 1;
  color: rgb(102 113 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#677189\\]{
  --tw-text-opacity: 1;
  color: rgb(103 113 137 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6FCBD4\\]{
  --tw-text-opacity: 1;
  color: rgb(111 203 212 / var(--tw-text-opacity, 1));
}
.text-\\[\\#71717A\\]{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#727272\\]{
  --tw-text-opacity: 1;
  color: rgb(114 114 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#73739B\\]{
  --tw-text-opacity: 1;
  color: rgb(115 115 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#777\\]{
  --tw-text-opacity: 1;
  color: rgb(119 119 119 / var(--tw-text-opacity, 1));
}
.text-\\[\\#84858D\\]{
  --tw-text-opacity: 1;
  color: rgb(132 133 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#858BA0\\]{
  --tw-text-opacity: 1;
  color: rgb(133 139 160 / var(--tw-text-opacity, 1));
}
.text-\\[\\#858DAA\\]{
  --tw-text-opacity: 1;
  color: rgb(133 141 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#858daa\\]{
  --tw-text-opacity: 1;
  color: rgb(133 141 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#868686\\]{
  --tw-text-opacity: 1;
  color: rgb(134 134 134 / var(--tw-text-opacity, 1));
}
.text-\\[\\#868C98\\]{
  --tw-text-opacity: 1;
  color: rgb(134 140 152 / var(--tw-text-opacity, 1));
}
.text-\\[\\#878787\\]{
  --tw-text-opacity: 1;
  color: rgb(135 135 135 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8C94A6\\]{
  --tw-text-opacity: 1;
  color: rgb(140 148 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8D8D91\\]{
  --tw-text-opacity: 1;
  color: rgb(141 141 145 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8E90A9\\]{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
.text-\\[\\#959595\\]{
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#961D14\\]{
  --tw-text-opacity: 1;
  color: rgb(150 29 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#963134\\]{
  --tw-text-opacity: 1;
  color: rgb(150 49 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A13E3F\\]{
  --tw-text-opacity: 1;
  color: rgb(161 62 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#AEB3C7\\]{
  --tw-text-opacity: 1;
  color: rgb(174 179 199 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B42318\\]{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B7BBC3\\]{
  --tw-text-opacity: 1;
  color: rgb(183 187 195 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B8B8B8\\]{
  --tw-text-opacity: 1;
  color: rgb(184 184 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BB371A\\]{
  --tw-text-opacity: 1;
  color: rgb(187 55 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D9D9D9\\]{
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#DC6803\\]{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E1E4EA\\]{
  --tw-text-opacity: 1;
  color: rgb(225 228 234 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E4B303\\]{
  --tw-text-opacity: 1;
  color: rgb(228 179 3 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F15D5F\\]{
  --tw-text-opacity: 1;
  color: rgb(241 93 95 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF681C\\]{
  --tw-text-opacity: 1;
  color: rgb(255 104 28 / var(--tw-text-opacity, 1));
}
.text-batchBlue{
  --tw-text-opacity: 1;
  color: rgb(42 83 146 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue{
  --tw-text-opacity: 1;
  color: rgb(42 83 146 / var(--tw-text-opacity, 1));
}
.text-body{
  --tw-text-opacity: 1;
  color: rgb(92 104 142 / var(--tw-text-opacity, 1));
}
.text-brandBlue{
  color: var(--color-primary);
}
.text-brandBlue4{
  --tw-text-opacity: 1;
  color: rgb(217 229 248 / var(--tw-text-opacity, 1));
}
.text-brandBlue50{
  --tw-text-opacity: 1;
  color: rgb(42 83 146 / var(--tw-text-opacity, 1));
}
.text-danger{
  --tw-text-opacity: 1;
  color: rgb(241 93 95 / var(--tw-text-opacity, 1));
}
.text-deepBlue{
  --tw-text-opacity: 1;
  color: rgb(11 28 86 / var(--tw-text-opacity, 1));
}
.text-deepBlue300{
  --tw-text-opacity: 1;
  color: rgb(92 104 142 / var(--tw-text-opacity, 1));
}
.text-dojahBlue{
  --tw-text-opacity: 1;
  color: rgb(63 124 219 / var(--tw-text-opacity, 1));
}
.text-dojahBlue-900{
  --tw-text-opacity: 1;
  color: rgb(3 57 113 / var(--tw-text-opacity, 1));
}
.text-error{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-error-300{
  --tw-text-opacity: 1;
  color: rgb(205 108 101 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(0 112 108 / var(--tw-text-opacity, 1));
}
.text-grey{
  --tw-text-opacity: 1;
  color: rgb(8 9 23 / var(--tw-text-opacity, 1));
}
.text-grey-200{
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}
.text-grey-500{
  --tw-text-opacity: 1;
  color: rgb(134 134 134 / var(--tw-text-opacity, 1));
}
.text-grey-700{
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}
.text-grey20{
  --tw-text-opacity: 1;
  color: rgb(142 144 169 / var(--tw-text-opacity, 1));
}
.text-grey30{
  --tw-text-opacity: 1;
  color: rgb(133 133 142 / var(--tw-text-opacity, 1));
}
.text-grey40{
  --tw-text-opacity: 1;
  color: rgb(132 133 141 / var(--tw-text-opacity, 1));
}
.text-grey5{
  --tw-text-opacity: 1;
  color: rgb(199 199 199 / var(--tw-text-opacity, 1));
}
.text-grey80{
  --tw-text-opacity: 1;
  color: rgb(51 52 66 / var(--tw-text-opacity, 1));
}
.text-grey90{
  --tw-text-opacity: 1;
  color: rgb(133 141 170 / var(--tw-text-opacity, 1));
}
.text-pending{
  --tw-text-opacity: 1;
  color: rgb(228 179 3 / var(--tw-text-opacity, 1));
}
.text-red{
  --tw-text-opacity: 1;
  color: rgb(243 120 122 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(151 17 34 / var(--tw-text-opacity, 1));
}
.text-secondaryBlue{
  --tw-text-opacity: 1;
  color: rgb(30 34 84 / var(--tw-text-opacity, 1));
}
.text-secondaryBlue80{
  --tw-text-opacity: 1;
  color: rgb(68 71 113 / var(--tw-text-opacity, 1));
}
.text-status-200{
  --tw-text-opacity: 1;
  color: rgb(74 135 141 / var(--tw-text-opacity, 1));
}
.text-status-400{
  --tw-text-opacity: 1;
  color: rgb(20 23 56 / var(--tw-text-opacity, 1));
}
.text-status-404{
  --tw-text-opacity: 1;
  color: rgb(161 62 63 / var(--tw-text-opacity, 1));
}
.text-status-500{
  --tw-text-opacity: 1;
  color: rgb(161 62 63 / var(--tw-text-opacity, 1));
}
.text-statusBg-200{
  --tw-text-opacity: 1;
  color: rgb(226 245 246 / var(--tw-text-opacity, 1));
}
.text-success{
  --tw-text-opacity: 1;
  color: rgb(74 135 141 / var(--tw-text-opacity, 1));
}
.text-success20{
  --tw-text-opacity: 1;
  color: rgb(226 245 246 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white80{
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.decoration-1{
  text-decoration-thickness: 1px;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.underline-offset-\\[3px\\]{
  text-underline-offset: 3px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-black::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(0 0 0 / var(--tw-placeholder-opacity, 1));
}
.caret-black{
  caret-color: #000;
}
.caret-brandBlue{
  caret-color: var(--color-primary);
}
.\\!accent-black{
  accent-color: #000 !important;
}
.accent-\\[\\#3F7CDB\\]{
  accent-color: #3F7CDB;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.mix-blend-multiply{
  mix-blend-mode: multiply;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 8px 30px rgb(0,0,0,0.12);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_3px_8px_0px_\\#00000026\\]{
  --tw-shadow: 0px 3px 8px 0px #00000026;
  --tw-shadow-colored: 0px 3px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cards{
  --tw-shadow: 0px 5px 3px -2px #00000005, 0px 3px 2px -2px #0000000F;
  --tw-shadow-colored: 0px 5px 3px -2px var(--tw-shadow-color), 0px 3px 2px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-filter{
  --tw-shadow: 0px 5px 3px -2px rgba(0, 0, 0, 0.02), 0px 3px 2px -2px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0px 5px 3px -2px var(--tw-shadow-color), 0px 3px 2px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-filter_dropdown{
  --tw-shadow: 0px 2px 6px 0px #0000000F,0px 6px 20px 0px #0000000F;
  --tw-shadow-colored: 0px 2px 6px 0px var(--tw-shadow-color), 0px 6px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-pagination{
  --tw-shadow: 0px 0px 0px 1px #464F603D;
  --tw-shadow-colored: 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-reconcilable{
  --tw-shadow: 0px 5px 3px -2px #3F7CDB05, 0px 3px 2px -2px #3F7CDB0F;
  --tw-shadow-colored: 0px 5px 3px -2px var(--tw-shadow-color), 0px 3px 2px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-tabs{
  --tw-shadow: 0px 2px 2px 0px #1018280A, 0px 1px 2px 0px #1018280A;
  --tw-shadow-colored: 0px 2px 2px 0px var(--tw-shadow-color), 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_32px_-4px\\2c rgba\\(199\\2c 196\\2c 196\\2c 0\\.18\\)\\]{
  --tw-shadow-color: 0px 4px 32px -4px,rgba(199,196,196,0.18);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brandBlue4{
  --tw-shadow-color: #D9E5F8;
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-dashed{
  outline-style: dashed;
}
.outline-0{
  outline-width: 0px;
}
.outline-1{
  outline-width: 1px;
}
.outline-2{
  outline-width: 2px;
}
.outline-offset-2{
  outline-offset: 2px;
}
.\\!outline-\\[\\#DFE1E7\\]{
  outline-color: #DFE1E7 !important;
}
.\\!outline-\\[\\#d7dde4\\]{
  outline-color: #d7dde4 !important;
}
.outline-\\[\\#A13E3F\\]{
  outline-color: #A13E3F;
}
.outline-\\[\\#D5D5D5\\]{
  outline-color: #D5D5D5;
}
.outline-\\[\\#e4e4e6\\]{
  outline-color: #e4e4e6;
}
.outline-\\[\\#eceff3\\]{
  outline-color: #eceff3;
}
.outline-blue-100{
  outline-color: #D1DCFF;
}
.outline-brandBlue{
  outline-color: var(--color-primary);
}
.outline-brandBlue60{
  outline-color: #9FBDED;
}
.outline-danger{
  outline-color: #F15D5F;
}
.outline-grey-50{
  outline-color: #F3F3F3;
}
.outline-grey5{
  outline-color: #c7c7c7;
}
.outline-grey60{
  outline-color: #CECED2;
}
.outline-grey80{
  outline-color: #333442;
}
.outline-red{
  outline-color: #F3787A;
}
.outline-status-404{
  outline-color: #A13E3F;
}
.outline-success{
  outline-color: #4A878D;
}
.outline-white80{
  outline-color: #FaFaFa;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[16px\\]{
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[4px\\]{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-height\\]{
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100{
  transition-delay: 100ms;
}
.delay-150{
  transition-delay: 150ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[box-shadow\\:0px_2px_6px_0px_\\#0000000F\\2c 0px_6px_20px_0px_\\#0000000F\\]{
  box-shadow: 0px 2px 6px 0px #0000000F,0px 6px 20px 0px #0000000F;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

:root {
  --color-primary: #3f7cdb;
}
.current-value {
  display: none !important;
}
.segment-value {
  font-weight: 100 !important;
}
text:first-child {
  transform: rotate(0deg) translate(-39%, 6%) !important;
}
text:last-child {
  transform: rotate(0deg) translate(38%, 6%) !important;
}
html {
  font-family: 'Inter', sans-serif;
  scroll-behavior: smooth;
}

.project_line_chart .apexcharts-legend-marker {
  border-radius: 50% !important;
}

.flag-select .ReactFlagsSelect-module_selectBtn__19wW7 {
  height: 38px;
  border-radius: 6px;
  font-size: 12px !important;
  color: #959595;
  border: 1px solid #d5d5d5;
  background: #fafafa;
}

.flag-select .ReactFlagsSelect-module_selectOptions__3LNBJ {
  font-size: 12px !important;
}

.filter-slide-container {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  overflow: hidden;
  transition: grid-template-rows 0.35s ease-in-out, opacity 0.35s ease-in-out,
    margin-top 0.35s ease-in-out;
  margin-top: 0;
  position: relative;
}

.filter-slide-container.open {
  grid-template-rows: 1fr;
  opacity: 1;
  overflow: visible;
  z-index: 20;
}

.filter-slide-container > * {
  min-height: 0;
}

/* additional styling */

aside::-webkit-scrollbar,
.custom-flow::-webkit-scrollbar,
.lookup-modal::-webkit-scrollbar,
.userApp::-webkit-scrollbar {
  position: relative;
  right: 40px;
  width: 5px !important;
}

aside::-webkit-scrollbar-track,
.custom-flow::-webkit-scrollbar-track,
.lookup-modal::-webkit-scrollbar-track,
.userApp::-webkit-scrollbar-track {
  background: none !important;
}

aside::-webkit-scrollbar-thumb,
.custom-flow::-webkit-scrollbar-thumb,
.lookup-modal::-webkit-scrollbar-thumb,
.userApp::-webkit-scrollbar-thumb {
  background-color: #ceced2 !important;
  border-radius: 10px !important;
}

.widget-footer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

[type='file'] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

[type='file'] + label {
  color: #3f7cdb;
  font-weight: 400;
}

[type='file']:focus + label,
[type='file'] + label:hover {
  cursor: pointer;
}

[type='file']:focus-visible + label {
  outline: 2px solid #000;
  border-radius: 2px;
}

/* custom react select styling */

.react-select__input-container,
.react-select-new-page__input-container {
  padding: 0 !important;
  margin: 0 !important;
}

.react-select__input {
  height: auto !important;
}

.react-select__placeholder,
.react-select-new-page__placeholder {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #8e90a9 !important;
}

.react-select__value-container,
.react-select-new-page__value-container {
  gap: 8px;
  padding: 0 !important;
}

.react-select__value-container--is-multi {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.react-select__option,
.react-select-new-page__option,
.react-select__single-value,
.react-select-new-page__single-value {
  font-size: 14px !important;
  color: #4a4a68 !important;
}

.react-select__option--is-focused,
.react-select-new-page__option--is-focused,
.react-select__option:hover .react-select-new-page__option:hover {
  background-color: #f1f1f1 !important;
}

.react-select__option--is-selected,
.react-select-new-page__option--is-selected {
  background-color: #333442 !important;
  color: #fff !important;
}

.apps-multi-select .react-select__option--is-selected,
.apps-multi-select .react-select-new-page__option--is-selected {
  background-color: var(--color-primary) !important;
}

.apps-multi-select .react-select__control {
  min-height: 48px !important;
}

.creatable-multi-select .react-select__control--is-focused:active,
.creatable-multi-select .react-select__control--is-focused:focus-within {
  border-width: 0 !important;
}

.apps-multi-select .react-select__option--is-selected:hover,
.apps-multi-select .react-select-new-page__option--is-selected:hover {
  background-color: var(--color-primary) !important;
}

.apps-multi-select .react-select__option {
  color: #080917 !important;
  font-size: 13px !important;
}

.apps-multi-select .react-select__option--is-selected {
  color: #fff !important;
}

.apps-multi-select .react-select__menu-list,
.apps-multi-select .react-select__menu-list--is-multi {
  padding: 8px !important;
}

.react-select__option--is-selected:hover,
.react-select-new-page__option--is-selected:hover {
  background-color: #333442 !important;
  color: #fff !important;
}

.react-select__multi-value {
  margin: 0 !important;
}

.react-select__clear-indicator,
.react-select-new-page__clear-indicator {
  display: none !important;
}

.react-select__control,
.react-select-new-page__control {
  padding-left: 16px !important;
  outline: 1px !important;
}

.react-select__control:hover,
.react-select-new-page__control:hover {
  outline-color: #ceced2 !important;
}

.react-select__control--is-focused,
.react-select-new-page__control--is-focused {
  outline-color: var(--color-primary) !important;
  outline-width: 1px !important;
}

.react-select__indicator-separator,
.react-select-new-page__indicator-separator {
  display: none !important;
}

.react-select__indicator,
.react-select-new-page__indicator {
  padding: 15px !important;
  padding-right: 16px !important;
}

.react-react-select__menu > p {
  text-align: left !important;
}
.react-select__menu {
  z-index: 20 !important;
}

.white-select > div {
  background-color: #fff !important;
  text-align: left !important;
}

/* multiselect */
.react-select__multi-value {
  background-color: var(--color-primary) !important;
  color: #d9e5f8;
  border-radius: 25px !important;
  flex-direction: row-reverse;
  gap: 4px;
  align-items: center !important;
  padding: 3px 8px !important;
  margin: 0 !important;
}

.react-select__multi-value__label {
  color: inherit !important;
  text-transform: uppercase;
  font-size: 10px !important;
  font-weight: 500;
  line-height: 12px;
  padding: 0 !important;
  position: relative;
}

.react-select__multi-value__remove {
  padding: 0 !important;
}

.react-select__multi-value__remove:hover {
  background-color: transparent !important;
}

.react-select__control--is-focused:active,
.react-select__control--is-focused:focus-within {
  outline-color: var(--color-primary) !important;
  outline-width: 1px !important;
  border-color: var(--color-primary) !important;
}

.react-select-new-page__menu-list {
  height: auto;
}

.react-select__group-heading span:first-child {
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #8e90a9 !important;
}

.creatable-multi-select .react-select__control {
  background-color: #fff !important;
  min-height: 48px !important;
}

.receive_webhook .creatable-multi-select .react-select__control {
  background-color: white !important;
}

.creatable-multi-select .react-select__input {
  font-size: 13px !important;
}

.creatable-multi-select .react-select__placeholder {
  margin-bottom: -4px;
}

.creditcheck-select .react-select__control {
  width: fit-content !important;
  margin-left: auto !important;
}

.creditcheck-select .react-select__menu {
  width: 70% !important;
  right: 0 !important;
}

.react-select__menu {
  z-index: 1000 !important;
}

.globalsearch .react-select__menu-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.globalsearch .react-select__option {
  padding: 8px !important;
}

/* custom phone input styling */

.phone-no-container {
  outline: 1px solid #d5d5d5 !important;
  border-radius: 4px !important;
}

.phone-no-container:active,
.phone-no-container:focus-within {
  outline: 1px solid #3f7cdb !important;
}

.phone-no-input {
  height: 48px !important;
  width: 100% !important;
  background-color: #fff !important;
  font-size: 13px !important;
  border-width: 0 !important;
  padding-left: 64px !important;
  font-family: 'Inter', sans-serif;
}

.phone-no-input:active,
.phone-no-input:focus-within {
  border-radius: 8px !important;
  border: none !important;
}

.flag-dropdown {
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  background-color: #f9f9f9 !important;
}

.selected-flag {
  padding-left: 16px !important;
  width: 56px !important;
}

.flag {
  margin-top: -6px !important;
}

.react-tel-input {
  max-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  background: #fff !important;
  border-radius: 8px !important;
}

.react-tel-input .selected-flag .arrow {
  left: 24px !important;
}

.react-tel-input .country-list {
  text-align: start !important;
}

.react-tel-input .country-list .country {
  font-size: 13px !important;
  color: #4a4a68 !important;
  font-family: 'Inter', sans-serif;
  font-weight: normal;
  padding: 8px 12px !important;
}

.react-tel-input .country-list .country.highlight {
  background-color: #fff !important;
  color: #fff !important;
}

.react-tel-input .country-list .country.highlight .dial-code {
  color: #fff !important;
}

.react-tel-input .country-list .search {
  padding: 10px !important;
}

.react-tel-input .country-list .search-box {
  padding: 8px !important;
}

.react-tel-input .country-list .no-entries-message {
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
}

.react-tel-input .form-control {
  outline: 0.5px solid #d5d5d5 !important;
  border-radius: 8px !important;
}

.react-tel-input .form-control:focus {
  outline: 1px solid #3f7cdb !important;
}

/* react toastify styles */

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  :root {
    --toastify-toast-min-height: 48px !important;
  }
}

.Toastify__toast-body {
  font-family: 'Inter', sans-serif !important;
  font-weight: 500;
}

.Toastify__toast {
  border-radius: 4px !important;
}

.Toastify__toast--success {
  background-color: var(--color-primary) !important;
  font-weight: 700 !important;
  max-height: 20px !important;
  font-size: 0.8rem;
  color: white !important;
}

.Toastify__toast--error {
  background-color: #bb371a !important;
  font-weight: 700 !important;
  font-size: 0.8rem;
  color: white !important;
}

.Toastify__progress-bar {
  visibility: hidden;
}

.Toastify__toast-icon {
  display: none !important;
}

.Toastify__close-button svg {
  fill: white !important;
}

.Toastify__toast-theme--light {
  max-width: 100% !important;
}

/* datepicker */

.lookup-filter .react-datepicker__input-container > input {
  font-size: 10px !important;
  font-weight: 500 !important;
  outline: none !important;
  height: 32px !important;
  cursor: pointer !important;
}

.react-datepicker {
  font-family: 'Inter', sans-serif !important;
}

.react-datepicker__year-option .react-datepicker__navigation--years-previous {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  border: none;
  inset: 0 !important;
  width: 16px;
  height: 16px;
}

.react-datepicker__year-option .react-datepicker__navigation--years-upcoming {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  border: none;
  transform: rotate(180deg);
  inset: 0 !important;
  width: 16px;
  height: 16px;
}

.lookup-image {
  background-position: center !important;
  background-size: cover !important;
  border-radius: 50%;
  background-repeat: no-repeat !important;
  display: inline-block;
  height: 80px;
  width: 80px;
  object-fit: contain;
}

.page-limit {
  display: flex;
  align-items: center;
  color: #5c688e;
  font-size: 13px;
}

.page-limit button {
  margin: 0 0.5rem;
  position: relative;
}

.page-limit .dropdown {
  position: absolute;
  width: 100%;
  color: #555;
  background: white;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  z-index: 10;
  top: 100%;
  right: 0;
  box-shadow: 0 5px 10px rgba(33, 33, 33, 0.12);
}

.page-limit .dropdown span {
  padding: 5px;
}

.page-limit .dropdown span:hover {
  background: #e3f5fa;
}

@keyframes skeleton-animation {
  0% {
    right: 100%;
  }

  50% {
    right: -128px;
  }

  100% {
    right: 100%;
  }
}

.skeleton {
  overflow: hidden;
  width: 328px;
  height: auto;
  display: grid;
  grid-template-columns: 128px 200px;
  grid-gap: 8px;
  position: relative;
  margin-bottom: 16px;
  /* margin-left: 7rem; */
  background: #eee;
}

.skeleton:before {
  display: block;
  position: absolute;
  width: 128px;
  height: 78px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    #fff,
    rgba(255, 255, 255, 0)
  );
  content: '';
  animation: skeleton-animation 1.25s infinite;
}

.skeleton .s-img {
  width: 128px;
  height: 78px;
  background: #eee;
  grid-row: 1 / 4;
}

.skeleton .s-line {
  height: 10px;
  background: #eee;
}

.skeleton .s-line.first {
  width: 100%;
}

.skeleton .s-line.second {
  width: 75%;
}

.skeleton .s-line.third {
  width: 50%;
}

.widget-radios {
  display: none;
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.widget-radios[type='checkbox'] + label {
  color: #677189;
  padding: 14px 32px !important;
  background-color: #f6f6f8;
  border: 1px solid #f6f6f8;
  border-radius: 40px;
  cursor: pointer;
  padding: 14px 24px;
}

.widget-radios[type='checkbox']:checked + label {
  color: #1b2a4e !important;
  padding: 14px 32px !important;
  background-color: lightgray;
  border: 1px solid #3977de;
  border-radius: 40px;
  cursor: pointer;
}

/* apexcharts  */
.apexcharts-tooltip {
  background: #fff !important;
  color: #1b2a4e !important;
  box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08),
    0 8px 16px rgba(50, 50, 71, 0.06) !important;
  border: 1px solid #fff !important;
}

.apexcharts-legend {
  gap: 16px !important;
  padding: 0 32px !important;
}

.apexcharts-legend-series {
  display: flex !important;
  align-items: flex-end !important;
  gap: 4px;
  margin: 0 !important;
}

.apexcharts-legend-marker {
  margin-right: 0 !important;
}

.apexcharts-legend-text {
  line-height: 12px !important;
  text-transform: uppercase;
  margin-top: 5px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hidden-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hidden-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: auto;
}

.activeSettingsTab {
  position: relative;
  color: #3f7cdb !important;
  display: inline-block;
}

.activeSettingsTab::before {
  content: '';
  position: absolute;
  inset: 0;
  border-bottom: 1px solid #3f7cdb;
}

progress::-moz-progress-bar {
  background: #3f7cdb;
  border-radius: 50px;
}

progress::-webkit-progress-value {
  background: #3f7cdb;
}

progress {
  width: 100%;
  background-color: #eee;
  border: 0;
  height: 18px;
  border-radius: 20px;
}

progress::-webkit-progress-bar {
  background-color: #eee;
  border: 0;
  height: 18px;
  border-radius: 20px;
}

progress::-webkit-progress-value {
  border: 0;
  height: 18px;
  border-radius: 20px;
}

progress::-moz-progress-bar {
  background-color: #eee;
  border: 0;
  height: 18px;
  border-radius: 20px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 80vh;
}

.truncated-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.liveness_slider {
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.liveness_slider input[type='range'] {
  width: 100%;
  height: 2px;
  /* background-color: black; */
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
}

.match_score input[type='range'] {
  width: 100%;
  height: 10px;
  /* background-color: black; */
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
}

.match_score input[type='range']::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.match_score input[type='range']::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.print_aml .header,
.print_aml .header-space {
  height: 50px;
}

.print_aml .footer,
.print_aml .footer-space {
  height: 50px;
}

.print_aml .header {
  position: fixed;
  top: 0;
  left: 0;
}

.print_aml .footer {
  position: fixed;
  bottom: 0;
  left: 0;
}

@page {
  margin: 10mm;
}

.pre {
  padding: 10px 40px !important;
  font-size: 13px !important;
}

.highlighter pre {
  font-size: 13px;
  padding: 20px 10px !important;
  border-radius: 12px;
}

.add_project_select .react-select__control {
  height: 38px;
}
.custom-questions-select .css-13cymwt-control {
  height: 56px;
  border-radius: 8px;
  border: 1px solid #f9f9f9;
  cursor: pointer;
}
.custom-questions-select .css-13cymwt-control:hover {
  border: 1px solid #f9f9f9 !important;
}
.custom-questions-select .css-1u9des2-indicatorSeparator {
  display: none;
}
.custom-questions-select .css-t3ipsp-control {
  border: 1px solid #f9f9f9 !important;
  box-shadow: none !important;
  border-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 0 1px #f9f9f9;
}
.custom-questions-select .css-1nmdiq5-menu {
  padding: 12px;
  background-color: #f0f3ff;
  border-radius: 8px;
}
.answer-option-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.answer-option-content.open {
  max-height: 500px;
}

.add_project_select .react-select__placeholder {
  color: #959595 !important;
  font-weight: 400;
}
.add_project_select .react-select__indicator {
  padding: 10px !important;
}

.project_line_chart .apexcharts-xaxis-label {
  font-size: 10px;
  text-transform: uppercase;
}
.project_line_chart .apexcharts-legend {
  overflow: hidden;
}
.project_line_chart text:first-child {
  transform: translate(0, 0) !important;
}
.project_line_chart text:last-child {
  transform: translate(0, 0) !important;
}

.project_line_chart .apexcharts-yaxis-label {
  font-size: 12px;
  text-transform: uppercase;
}

.required:after {
  content: ' *';
  color: #ca2b2b;
}

/* width */
.listbox-scroll::-webkit-scrollbar {
  width: 4px;
  border-radius: 12px;
}

/* Track */
.listbox-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 12px;
}

/* Handle */
.listbox-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 12px;
}

/* Handle on hover */
.listbox-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
  border-radius: 12px;
}

.select-verifications .react-select__control {
  background: rgb(from var(--color-primary) r g b / 0.13);
  border-color: rgb(from var(--color-primary) r g b / 0.23);
}

.select-verifications .react-select__option--is-selected {
  background: var(--color-primary) !important;
}

.select-verifications .react-select__control .react-select__single-value,
.select-verifications .react-select__control .react-select__placeholder {
  color: var(--color-primary) !important;
}

.custom-questions-select .css-13cymwt-control {
  height: 56px;
  border-radius: 8px;
  border: 1px solid #f9f9f9;
  cursor: pointer;
}
.custom-questions-select .css-13cymwt-control:hover {
  border: 1px solid #f9f9f9 !important;
}
.custom-questions-select .css-1u9des2-indicatorSeparator {
  display: none;
}
.custom-questions-select .css-t3ipsp-control {
  border: 1px solid #f9f9f9 !important;
  /*box-shadow: none !important;*/
  border-radius: 8px;
  box-shadow: 0 0 0 1px #f9f9f9;
}
.custom-questions-select .css-1nmdiq5-menu {
  padding: 12px;
  background-color: #f0f3ff;
  border-radius: 8px;
}
.answer-option-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.answer-option-content.open {
  max-height: 500px;
}

.spinner {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid #3f7cdb;
  border-right-color: rgba(255, 255, 255, 0.3);
  position: relative;
  animation: spin 0.3s linear infinite;
  -webkit-animation: spin 0.3s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.conditions-style::placeholder {
  color: black !important;
}
.conditions-style:focus::placeholder {
  color: #c2c2c2 !important;
}
.conditions-style::placeholder {
  color: black !important;
}
.conditions-style:focus::placeholder {
  color: #c2c2c2 !important;
}

.scrollbar-visible::-webkit-scrollbar {
  width: 10px;
}

.scrollbar-visible::-webkit-scrollbar-track {
  background: #d5d5d570;
  border-radius: 10px;
}

.scrollbar-visible::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border-radius: 10px;
  border: 3px solid transparent;
  background-clip: content-box;
}

.scrollbar-visible::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.placeholder\\:text-sm::placeholder{
  font-size: .8125rem;
  line-height: 18px;
}

.placeholder\\:text-tiny::placeholder{
  font-size: .875rem;
}

.placeholder\\:font-normal::placeholder{
  font-weight: 400;
}

.placeholder\\:italic::placeholder{
  font-style: italic;
}

.placeholder\\:text-grey::placeholder{
  --tw-text-opacity: 1;
  color: rgb(8 9 23 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-grey-200::placeholder{
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:-left-8::before{
  content: var(--tw-content);
  left: -2rem;
}

.before\\:left-\\[-3px\\]::before{
  content: var(--tw-content);
  left: -3px;
}

.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}

.before\\:top-1\\/2::before{
  content: var(--tw-content);
  top: 50%;
}

.before\\:-mt-\\[1px\\]::before{
  content: var(--tw-content);
  margin-top: -1px;
}

.before\\:h-\\[200px\\]::before{
  content: var(--tw-content);
  height: 200px;
}

.before\\:h-\\[5px\\]::before{
  content: var(--tw-content);
  height: 5px;
}

.before\\:h-full::before{
  content: var(--tw-content);
  height: 100%;
}

.before\\:w-\\[5px\\]::before{
  content: var(--tw-content);
  width: 5px;
}

.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-brandBlue::before{
  content: var(--tw-content);
  background-color: var(--color-primary);
}

.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}

.before\\:content-\\[\\'1\\.\\'\\]::before{
  --tw-content: '1.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'2\\.\\'\\]::before{
  --tw-content: '2.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'3\\.\\'\\]::before{
  --tw-content: '3.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'4\\.\\'\\]::before{
  --tw-content: '4.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'5\\.\\'\\]::before{
  --tw-content: '5.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'6\\.\\'\\]::before{
  --tw-content: '6.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'7\\.\\'\\]::before{
  --tw-content: '7.';
  content: var(--tw-content);
}

.before\\:content-\\[\\'\\\\00a0\\'\\]::before{
  --tw-content: '\\00a0';
  content: var(--tw-content);
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:-bottom-\\[3px\\]::after{
  content: var(--tw-content);
  bottom: -3px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:left-1\\/3::after{
  content: var(--tw-content);
  left: 33.333333%;
}

.after\\:right-\\[-3px\\]::after{
  content: var(--tw-content);
  right: -3px;
}

.after\\:top-3::after{
  content: var(--tw-content);
  top: 0.75rem;
}

.after\\:-z-10::after{
  content: var(--tw-content);
  z-index: -10;
}

.after\\:block::after{
  content: var(--tw-content);
  display: block;
}

.after\\:h-0::after{
  content: var(--tw-content);
  height: 0px;
}

.after\\:h-3::after{
  content: var(--tw-content);
  height: 0.75rem;
}

.after\\:h-\\[40px\\]::after{
  content: var(--tw-content);
  height: 40px;
}

.after\\:w-0::after{
  content: var(--tw-content);
  width: 0px;
}

.after\\:w-3::after{
  content: var(--tw-content);
  width: 0.75rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rotate-180::after{
  content: var(--tw-content);
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rotate-45::after{
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:border-b-4::after{
  content: var(--tw-content);
  border-bottom-width: 4px;
}

.after\\:border-l-4::after{
  content: var(--tw-content);
  border-left-width: 4px;
}

.after\\:border-r::after{
  content: var(--tw-content);
  border-right-width: 1px;
}

.after\\:border-r-4::after{
  content: var(--tw-content);
  border-right-width: 4px;
}

.after\\:border-dashed::after{
  content: var(--tw-content);
  border-style: dashed;
}

.after\\:border-grey60::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}

.after\\:border-b-\\[\\#4A4A68\\]::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(74 74 104 / var(--tw-border-opacity, 1));
}

.after\\:border-b-\\[\\#4A878D\\]::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(74 135 141 / var(--tw-border-opacity, 1));
}

.after\\:border-b-\\[\\#DC6803\\]::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}

.after\\:border-b-status-404::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(161 62 63 / var(--tw-border-opacity, 1));
}

.after\\:border-b-success::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(74 135 141 / var(--tw-border-opacity, 1));
}

.after\\:border-b-warning::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 193 7 / var(--tw-border-opacity, 1));
}

.after\\:border-l-transparent::after{
  content: var(--tw-content);
  border-left-color: transparent;
}

.after\\:border-r-transparent::after{
  content: var(--tw-content);
  border-right-color: transparent;
}

.after\\:bg-\\[var\\(--color-primary\\)\\]::after{
  content: var(--tw-content);
  background-color: var(--color-primary);
}

.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}

.first\\:border-t-0:first-child{
  border-top-width: 0px;
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-y:last-child{
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.last\\:border-b:last-child{
  border-bottom-width: 1px;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.last\\:border-none:last-child{
  border-style: none;
}

.last\\:border-b-grey60:last-child{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(206 206 210 / var(--tw-border-opacity, 1));
}

.hover\\:border-brandBlue:hover{
  border-color: var(--color-primary);
}

.hover\\:border-opacity-70:hover{
  --tw-border-opacity: 0.7;
}

.hover\\:bg-\\[\\#212b63\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(33 43 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#912018\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(145 32 24 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#963134\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(150 49 52 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#DAE4F4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(218 228 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#EBF1FC\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(235 241 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F2F6FD\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#d4b8e0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(212 184 224 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-brandBlue4:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 229 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-btnHover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(90 142 227 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-grey-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(221 221 221 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-grey-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white80:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-opacity-90:hover{
  --tw-bg-opacity: 0.9;
}

.hover\\:text-\\[\\#18181B\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-brandBlue:hover{
  color: var(--color-primary);
}

.hover\\:text-deepBlue:hover{
  --tw-text-opacity: 1;
  color: rgb(11 28 86 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:opacity-95:hover{
  opacity: 0.95;
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:outline:hover{
  outline-style: solid;
}

.hover\\:outline-1:hover{
  outline-width: 1px;
}

.focus\\:border-danger:focus{
  --tw-border-opacity: 1;
  border-color: rgb(241 93 95 / var(--tw-border-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline:focus{
  outline-style: solid;
}

.focus\\:outline-1:focus{
  outline-width: 1px;
}

.focus\\:outline-offset-2:focus{
  outline-offset: 2px;
}

.focus\\:outline-danger:focus{
  outline-color: #F15D5F;
}

.focus\\:outline-status-404:focus{
  outline-color: #A13E3F;
}

.focus\\:outline-white:focus{
  outline-color: #FFF;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:outline-1:focus-visible{
  outline-width: 1px;
}

.focus-visible\\:outline-brandBlue:focus-visible{
  outline-color: var(--color-primary);
}

.focus-visible\\:outline-danger:focus-visible{
  outline-color: #F15D5F;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-white:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-opacity-75:focus-visible{
  --tw-ring-opacity: 0.75;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-\\[\\#D5D5D5\\]:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(213 213 213 / var(--tw-bg-opacity, 1));
}

.disabled\\:text-\\[\\#959595\\]:disabled{
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}

.disabled\\:text-body:disabled{
  --tw-text-opacity: 1;
  color: rgb(92 104 142 / var(--tw-text-opacity, 1));
}

.disabled\\:no-underline:disabled{
  text-decoration-line: none;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.disabled\\:hover\\:bg-\\[\\#D5D5D5\\]:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(213 213 213 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:block{
  display: block;
}

@media (min-width: 640px){

  .sm\\:visible{
    visibility: visible;
  }

  .sm\\:absolute{
    position: absolute;
  }

  .sm\\:relative{
    position: relative;
  }

  .sm\\:top-0{
    top: 0px;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-0{
    margin-bottom: 0px;
  }

  .sm\\:ml-6{
    margin-left: 1.5rem;
  }

  .sm\\:ml-8{
    margin-left: 2rem;
  }

  .sm\\:mr-4{
    margin-right: 1rem;
  }

  .sm\\:mr-\\[75px\\]{
    margin-right: 75px;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-12{
    margin-top: 3rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mt-\\[51px\\]{
    margin-top: 51px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-\\[36px\\]{
    height: 36px;
  }

  .sm\\:max-h-\\[45\\%\\]{
    max-height: 45%;
  }

  .sm\\:max-h-full{
    max-height: 100%;
  }

  .sm\\:w-\\[277px\\]{
    width: 277px;
  }

  .sm\\:w-\\[425px\\]{
    width: 425px;
  }

  .sm\\:w-\\[80px\\]{
    width: 80px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-fit{
    width: fit-content;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-\\[238px\\]{
    max-width: 238px;
  }

  .sm\\:max-w-\\[352px\\]{
    max-width: 352px;
  }

  .sm\\:max-w-\\[406px\\]{
    max-width: 406px;
  }

  .sm\\:max-w-\\[450px\\]{
    max-width: 450px;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:basis-1\\/2{
    flex-basis: 50%;
  }

  .sm\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:translate-x-20{
    --tw-translate-x: 5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:translate-y-0{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-95{
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-10{
    gap: 2.5rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .sm\\:rounded-b-lg{
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .sm\\:border-b{
    border-bottom-width: 1px;
  }

  .sm\\:border-\\[\\#E4E4E6\\]{
    --tw-border-opacity: 1;
    border-color: rgb(228 228 230 / var(--tw-border-opacity, 1));
  }

  .sm\\:bg-white80{
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-\\[22px\\]{
    padding-left: 22px;
    padding-right: 22px;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-4{
    padding-left: 1rem;
  }

  .sm\\:pl-6{
    padding-left: 1.5rem;
  }

  .sm\\:pr-0{
    padding-right: 0px;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:pt-10{
    padding-top: 2.5rem;
  }

  .sm\\:pt-6{
    padding-top: 1.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-lg{
    font-size: 1.25rem;
    line-height: 28px;
  }

  .sm\\:text-sm{
    font-size: .8125rem;
    line-height: 18px;
  }

  .sm\\:text-xl{
    font-size: 1.5625rem;
    line-height: 30px;
  }

  .sm\\:leading-\\[18px\\]{
    line-height: 18px;
  }

  .sm\\:text-brandBlue{
    color: var(--color-primary);
  }
}

@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:bottom-6{
    bottom: 1.5rem;
  }

  .md\\:left-0{
    left: 0px;
  }

  .md\\:right-6{
    right: 1.5rem;
  }

  .md\\:right-\\[-16px\\]{
    right: -16px;
  }

  .md\\:mb-0{
    margin-bottom: 0px;
  }

  .md\\:mt-10{
    margin-top: 2.5rem;
  }

  .md\\:mt-12{
    margin-top: 3rem;
  }

  .md\\:mt-4{
    margin-top: 1rem;
  }

  .md\\:mt-6{
    margin-top: 1.5rem;
  }

  .md\\:mt-\\[12px\\]{
    margin-top: 12px;
  }

  .md\\:mt-\\[27px\\]{
    margin-top: 27px;
  }

  .md\\:mt-\\[2px\\]{
    margin-top: 2px;
  }

  .md\\:mt-\\[32px\\]{
    margin-top: 32px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-\\[356px\\]{
    height: 356px;
  }

  .md\\:h-\\[60px\\]{
    height: 60px;
  }

  .md\\:h-\\[660px\\]{
    height: 660px;
  }

  .md\\:h-\\[750px\\]{
    height: 750px;
  }

  .md\\:h-\\[89\\%\\]{
    height: 89%;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-\\[250px\\]{
    width: 250px;
  }

  .md\\:w-\\[30\\%\\]{
    width: 30%;
  }

  .md\\:w-\\[300px\\]{
    width: 300px;
  }

  .md\\:w-\\[34\\.4\\%\\]{
    width: 34.4%;
  }

  .md\\:w-\\[44\\.4\\%\\]{
    width: 44.4%;
  }

  .md\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .md\\:w-\\[536px\\]{
    width: 536px;
  }

  .md\\:w-\\[70\\%\\]{
    width: 70%;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:min-w-\\[250px\\]{
    min-width: 250px;
  }

  .md\\:max-w-\\[408px\\]{
    max-width: 408px;
  }

  .md\\:max-w-\\[427px\\]{
    max-width: 427px;
  }

  .md\\:max-w-\\[500px\\]{
    max-width: 500px;
  }

  .md\\:max-w-\\[600px\\]{
    max-width: 600px;
  }

  .md\\:max-w-full{
    max-width: 100%;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-0{
    gap: 0px;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:rounded{
    border-radius: 0.25rem;
  }

  .md\\:rounded-none{
    border-radius: 0px;
  }

  .md\\:border-b-\\[\\#F2F2F2\\]{
    --tw-border-opacity: 1;
    border-bottom-color: rgb(242 242 242 / var(--tw-border-opacity, 1));
  }

  .md\\:border-l-\\[\\#F2F2F2\\]{
    --tw-border-opacity: 1;
    border-left-color: rgb(242 242 242 / var(--tw-border-opacity, 1));
  }

  .md\\:bg-\\[\\#F2F6FD\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(242 246 253 / var(--tw-bg-opacity, 1));
  }

  .md\\:bg-brandBlue{
    background-color: var(--color-primary);
  }

  .md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .md\\:bg-white80{
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-\\[21px\\]{
    padding-top: 21px;
    padding-bottom: 21px;
  }

  .md\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .md\\:pt-10{
    padding-top: 2.5rem;
  }

  .md\\:pt-14{
    padding-top: 3.5rem;
  }

  .md\\:text-start{
    text-align: start;
  }

  .md\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 24px;
  }

  .md\\:text-\\[\\#242424\\]{
    --tw-text-opacity: 1;
    color: rgb(36 36 36 / var(--tw-text-opacity, 1));
  }

  .md\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }

  .md\\:opacity-80{
    opacity: 0.8;
  }

  .md\\:shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mx-\\[147px\\]{
    margin-left: 147px;
    margin-right: 147px;
  }

  .lg\\:-mb-\\[2px\\]{
    margin-bottom: -2px;
  }

  .lg\\:ml-10{
    margin-left: 2.5rem;
  }

  .lg\\:ml-8{
    margin-left: 2rem;
  }

  .lg\\:ml-\\[16\\.4\\%\\]{
    margin-left: 16.4%;
  }

  .lg\\:ml-\\[50px\\]{
    margin-left: 50px;
  }

  .lg\\:ml-auto{
    margin-left: auto;
  }

  .lg\\:mr-8{
    margin-right: 2rem;
  }

  .lg\\:mt-0{
    margin-top: 0px;
  }

  .lg\\:mt-14{
    margin-top: 3.5rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:w-1\\/2{
    width: 50%;
  }

  .lg\\:w-\\[16\\.4\\%\\]{
    width: 16.4%;
  }

  .lg\\:w-\\[260px\\]{
    width: 260px;
  }

  .lg\\:w-\\[33\\%\\]{
    width: 33%;
  }

  .lg\\:w-\\[400px\\]{
    width: 400px;
  }

  .lg\\:w-\\[455px\\]{
    width: 455px;
  }

  .lg\\:w-\\[67\\%\\]{
    width: 67%;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:w-fit{
    width: fit-content;
  }

  .lg\\:min-w-\\[164px\\]{
    min-width: 164px;
  }

  .lg\\:min-w-\\[180px\\]{
    min-width: 180px;
  }

  .lg\\:min-w-\\[183px\\]{
    min-width: 183px;
  }

  .lg\\:max-w-3xl{
    max-width: 48rem;
  }

  .lg\\:max-w-72{
    max-width: 18rem;
  }

  .lg\\:max-w-\\[288px\\]{
    max-width: 288px;
  }

  .lg\\:max-w-\\[78\\.39\\%\\]{
    max-width: 78.39%;
  }

  .lg\\:max-w-\\[800px\\]{
    max-width: 800px;
  }

  .lg\\:grow-0{
    flex-grow: 0;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[56\\%\\2c 44\\%\\]{
    grid-template-columns: 56% 44%;
  }

  .lg\\:grid-cols-\\[56\\%_44\\%\\]{
    grid-template-columns: 56% 44%;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-0{
    gap: 0px;
  }

  .lg\\:gap-10{
    gap: 2.5rem;
  }

  .lg\\:gap-12{
    gap: 3rem;
  }

  .lg\\:gap-4{
    gap: 1rem;
  }

  .lg\\:gap-5{
    gap: 1.25rem;
  }

  .lg\\:rounded-l-2xl{
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .lg\\:rounded-l-none{
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .lg\\:rounded-l-xl{
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .lg\\:rounded-r-2xl{
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .lg\\:rounded-r-none{
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .lg\\:rounded-r-xl{
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .lg\\:rounded-t-lg{
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .lg\\:border-r-\\[\\#E1E4EA\\]{
    --tw-border-opacity: 1;
    border-right-color: rgb(225 228 234 / var(--tw-border-opacity, 1));
  }

  .lg\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:p-0{
    padding: 0px;
  }

  .lg\\:p-\\[42px\\]{
    padding: 42px;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-\\[40px\\]{
    padding-left: 40px;
    padding-right: 40px;
  }

  .lg\\:px-\\[47px\\]{
    padding-left: 47px;
    padding-right: 47px;
  }

  .lg\\:px-\\[63px\\]{
    padding-left: 63px;
    padding-right: 63px;
  }

  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:py-\\[14px\\]{
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .lg\\:py-\\[4px\\]{
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .lg\\:pl-0{
    padding-left: 0px;
  }

  .lg\\:pl-6{
    padding-left: 1.5rem;
  }

  .lg\\:pl-\\[38px\\]{
    padding-left: 38px;
  }

  .lg\\:pl-\\[41\\.38\\%\\]{
    padding-left: 41.38%;
  }

  .lg\\:pr-24{
    padding-right: 6rem;
  }

  .lg\\:pr-6{
    padding-right: 1.5rem;
  }

  .lg\\:pr-9{
    padding-right: 2.25rem;
  }

  .lg\\:pr-\\[26\\.46\\%\\]{
    padding-right: 26.46%;
  }

  .lg\\:pt-0{
    padding-top: 0px;
  }

  .lg\\:text-right{
    text-align: right;
  }

  .lg\\:text-\\[12px\\]{
    font-size: 12px;
  }

  .lg\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .lg\\:text-sm{
    font-size: .8125rem;
    line-height: 18px;
  }

  .lg\\:text-tiny{
    font-size: .875rem;
  }

  .lg\\:text-\\[\\#0e122a\\]{
    --tw-text-opacity: 1;
    color: rgb(14 18 42 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}

@media (min-width: 1280px){

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:top-\\[15px\\]{
    top: 15px;
  }

  .xl\\:top-\\[35px\\]{
    top: 35px;
  }

  .xl\\:-mr-\\[76px\\]{
    margin-right: -76px;
  }

  .xl\\:ml-0{
    margin-left: 0px;
  }

  .xl\\:ml-12{
    margin-left: 3rem;
  }

  .xl\\:ml-4{
    margin-left: 1rem;
  }

  .xl\\:ml-8{
    margin-left: 2rem;
  }

  .xl\\:ml-\\[37px\\]{
    margin-left: 37px;
  }

  .xl\\:mr-\\[-76px\\]{
    margin-right: -76px;
  }

  .xl\\:mt-0{
    margin-top: 0px;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:w-\\[33\\%\\]{
    width: 33%;
  }

  .xl\\:w-\\[67\\%\\]{
    width: 67%;
  }

  .xl\\:max-w-\\[1000px\\]{
    max-width: 1000px;
  }

  .xl\\:grow-0{
    flex-grow: 0;
  }

  .xl\\:basis-\\[31\\.83\\%\\]{
    flex-basis: 31.83%;
  }

  .xl\\:basis-\\[32\\.83\\%\\]{
    flex-basis: 32.83%;
  }

  .xl\\:basis-\\[36\\%\\]{
    flex-basis: 36%;
  }

  .xl\\:basis-\\[36\\.04\\%\\]{
    flex-basis: 36.04%;
  }

  .xl\\:basis-\\[43\\.91\\%\\]{
    flex-basis: 43.91%;
  }

  .xl\\:basis-\\[45\\.67\\%\\]{
    flex-basis: 45.67%;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[37\\%_37\\%_22\\%\\]{
    grid-template-columns: 37% 37% 22%;
  }

  .xl\\:grid-cols-\\[auto_auto_auto\\]{
    grid-template-columns: auto auto auto;
  }

  .xl\\:grid-cols-\\[auto_auto_auto_auto\\]{
    grid-template-columns: auto auto auto auto;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:flex-col{
    flex-direction: column;
  }

  .xl\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .xl\\:items-start{
    align-items: flex-start;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }

  .xl\\:gap-0{
    gap: 0px;
  }

  .xl\\:border-none{
    border-style: none;
  }

  .xl\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .xl\\:bg-white80{
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  }

  .xl\\:p-2{
    padding: 0.5rem;
  }

  .xl\\:p-8{
    padding: 2rem;
  }

  .xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:px-\\[12\\.5\\%\\]{
    padding-left: 12.5%;
    padding-right: 12.5%;
  }

  .xl\\:px-\\[80px\\]{
    padding-left: 80px;
    padding-right: 80px;
  }

  .xl\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .xl\\:pb-\\[8vh\\]{
    padding-bottom: 8vh;
  }

  .xl\\:pl-12{
    padding-left: 3rem;
  }

  .xl\\:pl-4{
    padding-left: 1rem;
  }

  .xl\\:pl-8{
    padding-left: 2rem;
  }

  .xl\\:pl-\\[49\\.38\\%\\]{
    padding-left: 49.38%;
  }

  .xl\\:pr-16{
    padding-right: 4rem;
  }

  .xl\\:pr-8{
    padding-right: 2rem;
  }

  .xl\\:pr-\\[31\\.46\\%\\]{
    padding-right: 31.46%;
  }

  .xl\\:pr-\\[76px\\]{
    padding-right: 76px;
  }

  .xl\\:pt-\\[35px\\]{
    padding-top: 35px;
  }

  .xl\\:pt-\\[36px\\]{
    padding-top: 36px;
  }

  .xl\\:pt-\\[3px\\]{
    padding-top: 3px;
  }

  .xl\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .xl\\:text-\\[9px\\]{
    font-size: 9px;
  }

  .xl\\:text-base{
    font-size: 1rem;
    line-height: 24px;
  }

  .xl\\:text-md{
    font-size: 1.5rem;
  }

  .xl\\:text-sm{
    font-size: .8125rem;
    line-height: 18px;
  }

  .xxl\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .xxl\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .xxl\\:flex-row{
    flex-direction: row;
  }

  .xxl\\:items-center{
    align-items: center;
  }
}

@media (min-width: 1440px){

  .xxxl\\:w-\\[40\\%\\]{
    width: 40%;
  }

  .xxxl\\:w-\\[60\\%\\]{
    width: 60%;
  }

  .xxxl\\:min-w-\\[270px\\]{
    min-width: 270px;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:max-w-\\[400px\\]{
    max-width: 400px;
  }
}

@media (min-width: 1700px){

  .\\33xl\\:right-\\[39\\%\\]{
    right: 39%;
  }

  .\\33xl\\:h-full{
    height: 100%;
  }

  .\\33xl\\:max-w-\\[430px\\]{
    max-width: 430px;
  }
}

@media print{

  .print\\:block{
    display: block;
  }

  .print\\:flex{
    display: flex;
  }

  .print\\:hidden{
    display: none;
  }

  .print\\:items-center{
    align-items: center;
  }

  .print\\:justify-between{
    justify-content: space-between;
  }

  .print\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/tailwind.css"],"names":[],"mappings":"AAGA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,oCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAiHhB;;EAAA,YAAuH;EAAvH,WAAuH;EAAvH,qBAAuH;EAAvH,kBAAuH;EAAvH,4DAAuH;EAAvH,iBAAuH;EAAvH,oBAAuH;EAAvH,kBAAuH;EAAvH,mBAAuH;EAAvH,oBAAuH;EAAvH,oBAAuH;EAAvH;AAAuH;AAAvH;;EAAA,oBAAuH;EAAvH;AAAuH;AAIvH;EAAA,YAAwH;EAAxH,WAAwH;EAAxH,qBAAwH;EAAxH,6BAAwH;EAAxH,uEAAwH;EAAxH,iBAAwH;EAAxH,oBAAwH;EAAxH,kBAAwH;EAAxH,mBAAwH;EAAxH,oBAAwH;EAAxH,oBAAwH;EAAxH;AAAwH;AAAxH;EAAA,oBAAwH;EAAxH;AAAwH;AAIxH;EAAA,YAA4J;EAA5J,WAA4J;EAA5J,qBAA4J;EAA5J,kBAA4J;EAA5J,4DAA4J;EAA5J,gBAA4J;EAA5J,mBAA4J;EAA5J,oBAA4J;EAA5J,sBAA4J;EAA5J,oBAA4J;EAA5J,kBAA4J;EAA5J,iBAA4J;EAA5J,gBAA4J;EAA5J,oBAA4J;EAA5J,8CAA4J;EAA5J,oBAA4J;EAA5J,oBAA4J;EAA5J;AAA4J;AAA5J;EAAA,oBAA4J;EAA5J;AAA4J;AAI5J;EAAA,YAA0H;EAA1H,WAA0H;EAA1H,qBAA0H;EAA1H,kBAA0H;EAA1H,4DAA0H;EAA1H,kBAA0H;EAA1H,mBAA0H;EAA1H,oBAA0H;EAA1H,mBAA0H;EAA1H,iBAA0H;EAA1H,oBAA0H;EAA1H,oBAA0H;EAA1H;AAA0H;AAA1H;EAAA,oBAA0H;EAA1H;AAA0H;AAI1H;EAAA,cAAkH;EAAlH,WAAkH;EAAlH,qBAAkH;EAAlH,kBAAkH;EAAlH,4DAAkH;EAAlH,oBAAkH;EAAlH,qBAAkH;EAAlH,mBAAkH;EAAlH,oBAAkH;EAAlH,oBAAkH;EAAlH;AAAkH;AAAlH;EAAA,oBAAkH;EAAlH;AAAkH;AAIlH;EAAA,eAA6B;EAA7B;AAA6B;AAI7B;EAAA,aAA8E;EAA9E,eAA8E;EAA9E,sBAA8E;EAA9E,uBAA8E;EAA9E,mBAA8E;EAA9E,iBAA8E;EAA9E,gBAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAI9E;EAAA,aAA8E;EAA9E,eAA8E;EAA9E,sBAA8E;EAA9E,uBAA8E;EAA9E,kBAA8E;EAA9E,iBAA8E;EAA9E,gBAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;AAQ9E;;;;;EAAA,oBAA0C;EAA1C,kBAA0C;EAA1C;AAA0C;AAI1C;EAAA,YAAyH;EAAzH,qBAAyH;EAAzH,kBAAyH;EAAzH,kBAAyH;EAAzH,4DAAyH;EAAzH,mBAAyH;EAAzH,sBAAyH;EAAzH,oBAAyH;EAAzH,mBAAyH;EAAzH,iBAAyH;EAAzH,gBAAyH;EAAzH,oBAAyH;EAAzH,mDAAyH;EAAzH,kBAAyH;EAAzH;AAAyH;AAKzH;;EAAA,kCAAoC;EAApC,8BAAoC;EAApC;AAAoC;AAGtC;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;AAEA,wCAAwC;AACxC;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;AAGE;EAAA,mBAAgI;EAAhI,kBAAgI;EAAhI,4DAAgI;EAAhI,oBAAgI;EAAhI;AAAgI;AAAhI;EAAA,kBAAgI;EAAhI,4DAAgI;EAAhI,oBAAgI;EAAhI;AAAgI;AAIhI;EAAA,iBAA+G;EAA/G,yBAA+G;EAA/G,wBAA+G;EAA/G,wDAA+G;EAA/G;AAA+G;AAA/G;EAAA,sBAA+G;EAA/G;AAA+G;AAA/G;EAAA,sBAA+G;EAA/G;AAA+G;AAI/G;EAAA,kBAAsD;EAAtD,kBAAsD;EAAtD,UAAsD;EAAtD,4BAAsD;EAAtD,wDAAsD;EAAtD;AAAsD;AAItD;EAAA,mBAAmE;EAAnE,WAAmE;EAAnE,UAAmE;EAAnE,wJAAmE;EAAnE,0BAAmE;EAAnE;AAAmE;AAGrE;IACE,wBAAwB;EAC1B;AAEA;IACE;;;;;;;;;OASG;IACH,2BAA2B;IAC3B,4CAA4C;EAC9C;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,YAAY,EAAE,iBAAiB;IAC/B;;;;KAIC;IACD;+BAC2B;IAE3B,uBAAuB;IACvB,oBAAoB;EACtB;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;IACzD,yBAAyB;EAC3B;AAaE;EAAA,sBAAoF;EAApF,iBAAoF;EAApF,kCAAoF;EAApF,kBAAoF;EAApF,4DAAoF;EAApF,aAAoF;EAApF,mBAAoF;EAApF,iBAAoF;EAApF,2BAAoF;EAApF,6EAAoF;EAApF,iGAAoF;EAApF;AAAoF;AAEtF;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACA;IACE,wBAAwB;EAC1B;AAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;AAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,UAAU;EACZ;AAEA;IACE,gBAAgB;IAEhB,gBAAgB;IAChB,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,yEAAqE;IACrE,wCAAwC;EAC1C;AAEA;IACE,uCAAuC;EACzC;AAEA,WAAW;AACX;IACE,aAAa;EACf;AAEA;;IAGE,gBAAgB;IAChB,SAAS;EACX;AAEA,YAAY;AACZ;IAEE,gBAAgB;EAClB;AAEA;;IAEE,yBAAyB;IACzB,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;EAChB;AAEA;IACE,oCAAoC;IACpC,YAAY;EACd;AAOA;;IAEE,oCAAoC;EACtC;AAEA;;IAEE,wBAAwB;EAC1B;AAEA;;IAEE,oCAAoC;EACtC;AAEA;IACE,wBAAwB;EAC1B;AAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;AAEA;IACE,wBAAwB;EAC1B;AAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;AAEA;;IAEE,oCAAoC;EACtC;AAEA;IACE,mBAAmB;EACrB;AAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;AAEA;;IAEE,oCAAoC;EACtC;AAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;AAEA;;IAEE,oCAAoC;EACtC;AAEA;IACE,aAAa;EACf;AAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;AAEA;IACE,WAAW;IACX,YAAY;EACd;AAEA;IACE,aAAa;EACf;AAEA,yBAAyB;AACzB;IACE,gCAAgC;EAClC;AAEA;IACE,gCAAgC;EAClC;AA7aF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,wBAAwB;EACxB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sDAAsD;AACxD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB;gCAC8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAqUA,uBAAuB;;AAEvB;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;EAIE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yDAA+D;AACjE;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,gCAAgC;;AAEhC;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;;;EAIE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,iDAAiD;EACjD,cAAc;EACd,8BAA8B;EAC9B,2BAA2B;EAC3B,QAAQ;EACR,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,8CAA8C;EAC9C,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;;AAE/B;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,0BAA0B;;AAE1B;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;;AAEf;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6DAA8D;EAC9D,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA8D;EAC9D,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ;;;;;GAKC;EACD,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EAIf,kBAAkB;AAHpB;;AAMA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,yBAAyB;EACzB;gDAC8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,WAAW;EAMX,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;AANrB;;AASA;EACE,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AASA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAn6CA;EAAA,mBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,gBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,qBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,mBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,0BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,gBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,qBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,0CAo6CA;EAp6CA,uDAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,sBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,8BAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,2GAo6CA;EAp6CA,yGAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,2GAo6CA;EAp6CA,yGAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,2GAo6CA;EAp6CA,yGAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA,oBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;EAAA,kBAo6CA;EAp6CA;AAo6CA;;AAp6CA;EAAA;AAo6CA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,gBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,qBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,sBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,qBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,eAo6CA;IAp6CA,eAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,kCAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,sBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,mBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,mBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,sBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,sBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,gBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,eAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,+EAo6CA;IAp6CA,mGAo6CA;IAp6CA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,gBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,4BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,2BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,+BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,6BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,4BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,gCAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,8BAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,sBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,qBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,gBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,mBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,qBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,oBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,mBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,kBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA,gBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,eAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,mBAo6CA;IAp6CA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;AAAA;;AAp6CA;;EAAA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA;EAo6CA;;EAp6CA;IAAA,iBAo6CA;IAp6CA;EAo6CA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sometype+Mono:wght@400;500&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('./assets/fonts/MonaSans-ExtraBold.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  --color-primary: #3f7cdb;\n}\n.current-value {\n  display: none !important;\n}\n.segment-value {\n  font-weight: 100 !important;\n}\ntext:first-child {\n  transform: rotate(0deg) translate(-39%, 6%) !important;\n}\ntext:last-child {\n  transform: rotate(0deg) translate(38%, 6%) !important;\n}\nhtml {\n  font-family: 'Inter', sans-serif;\n  scroll-behavior: smooth;\n}\n\n.project_line_chart .apexcharts-legend-marker {\n  border-radius: 50% !important;\n}\n\n.flag-select .ReactFlagsSelect-module_selectBtn__19wW7 {\n  height: 38px;\n  border-radius: 6px;\n  font-size: 12px !important;\n  color: #959595;\n  border: 1px solid #d5d5d5;\n  background: #fafafa;\n}\n\n.flag-select .ReactFlagsSelect-module_selectOptions__3LNBJ {\n  font-size: 12px !important;\n}\n\n.filter-slide-container {\n  display: grid;\n  grid-template-rows: 0fr;\n  opacity: 0;\n  overflow: hidden;\n  transition: grid-template-rows 0.35s ease-in-out, opacity 0.35s ease-in-out,\n    margin-top 0.35s ease-in-out;\n  margin-top: 0;\n  position: relative;\n}\n\n.filter-slide-container.open {\n  grid-template-rows: 1fr;\n  opacity: 1;\n  overflow: visible;\n  z-index: 20;\n}\n\n.filter-slide-container > * {\n  min-height: 0;\n}\n\n@layer components {\n  input,\n  select {\n    @apply bg-white outline outline-[0.5px] outline-[#D5D5D5] py-[10px] px-4 h-12 w-full rounded-lg placeholder:text-grey20;\n  }\n\n  input[data-bg='white'] {\n    @apply !bg-white outline outline-[0.5px] outline-[#D5D5D5] py-[10px] px-4 h-12 w-full rounded-lg placeholder:text-grey20;\n  }\n\n  select[data-smallerselect] {\n    @apply bg-white outline outline-[0.5px] outline-[#D5D5D5] pl-2 pr-7 py-0 pt-1 h-[28px] w-32 rounded-lg placeholder:text-grey20 text-grey font-medium text-xs;\n  }\n\n  textarea {\n    @apply w-full h-32 px-4 pt-3 rounded-lg bg-white outline outline-[0.5px] outline-[#D5D5D5] placeholder:text-grey20 text-sm;\n  }\n\n  textarea[data-smallertextarea] {\n    @apply w-full px-2 pt-2 rounded-lg h-22 bg-white outline outline-[0.5px] outline-[#D5D5D5] placeholder:text-grey20;\n  }\n\n  input[type='checkbox'] {\n    @apply cursor-pointer outline;\n  }\n\n  label {\n    @apply flex flex-col items-start max-w-full text-sm text-[#4E4E4E] font-normal;\n  }\n\n  label[data-smallerlabel] {\n    @apply flex flex-col items-start max-w-full text-xs font-normal text-[#4E4E4E];\n  }\n\n  input[type='search']:focus-visible,\n  input:focus-visible,\n  input:focus-within,\n  select:focus-visible,\n  textarea:focus-visible {\n    @apply outline outline-1 outline-brandBlue;\n  }\n\n  input[type='search'] {\n    @apply border-none outline-[#EBEBEB] pl-10 py-2 text-sm font-normal text-[#AEB3C7] h-[36px] bg-white rounded-lg outline-1;\n  }\n\n  input[type='radio'],\n  input[type='checkbox'] {\n    @apply outline-none accent-brandBlue;\n  }\n\n  input[type='date'] {\n    position: relative;\n    height: 48px;\n    width: 100%;\n  }\n\n  /*noinspection CssOverwrittenProperties*/\n  input[type='date']::-webkit-calendar-picker-indicator {\n    position: absolute;\n    transform: scaleX(-1);\n    cursor: pointer;\n    right: 16px;\n    padding: 16px;\n    margin-right: -16px;\n    padding-left: 16px;\n    width: 100%;\n  }\n\n  button {\n    @apply disabled:bg-white80 disabled:text-grey30 disabled:hover:bg-white80 disabled:hover:text-grey30 disabled:cursor-not-allowed;\n  }\n\n  .card-link {\n    @apply transition-all duration-200 border border-transparent hover:border-brandBlue60 active:border-brandBlue40;\n  }\n\n  .tooltip {\n    @apply absolute invisible transition-opacity opacity-0;\n  }\n\n  .has-tooltip:hover .tooltip {\n    @apply z-50 visible transition duration-300 ease-in-out opacity-100;\n  }\n\n  iframe#webpack-dev-server-client-overlay {\n    display: none !important;\n  }\n\n  .secondary_button {\n    background: linear-gradient(\n        0deg,\n        var(--White, #ffffff),\n        var(--White, #ffffff)\n      ),\n      linear-gradient(\n        180deg,\n        rgba(223, 225, 231, 0) 0%,\n        rgba(223, 225, 231, 0.05) 100%\n      );\n    border: 1px solid #12376914;\n    box-shadow: 0px -1px 2px 0px #12376914 inset;\n  }\n\n  .primary_button {\n    position: relative;\n    border: none;\n    z-index: 1;\n  }\n\n  .primary_button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: inherit;\n    padding: 1px; /* Border width */\n    background: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.2) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n\n  .tooltip::before {\n    content: '';\n    position: absolute;\n    top: -14px;\n    border-width: 8px;\n    border-style: solid;\n    border-color: #444771 transparent transparent transparent;\n    transform: rotate(180deg);\n  }\n\n  .widget-form input,\n  .widget-form textarea,\n  .widget-form select {\n    @apply outline outline-1 -outline-offset-1 outline-grey60 focus-within:outline-brandBlue focus-visible:outline-brandBlue;\n  }\n\n  .widget-form input[type='radio'] {\n    @apply h-auto rounded-full accent-black outline-none outline-0 focus-visible:outline focus-visible:outline-1 focus-visible:outline-brandBlue w-auto;\n  }\n\n  .google-translate-dropdown {\n    @apply bg-white text-brandBlue border border-brandBlue rounded shadow-md p-4 text-sm;\n  }\n  .google-translate-dropdown .goog-te-gadget-simple {\n    border: none !important;\n    display: flex !important;\n  }\n  .google-translate-dropdown .goog-te-gadget-simple span a {\n    display: flex !important;\n  }\n\n  .logs-tr .logs-code span {\n    /* display: none; */\n    transition: all 0.5s ease-in-out;\n    transform: translateX(-3px);\n    visibility: hidden;\n    opacity: 0;\n    width: 2px;\n  }\n\n  .logs-tr:hover .logs-code span {\n    /* display: block; */\n    visibility: visible;\n    transform: translateX(3px);\n    transition: 0.3s ease-in-out;\n    width: 100%;\n    opacity: 1;\n  }\n\n  select {\n    /* for Firefox */\n    -moz-appearance: none;\n    appearance: none;\n    /* for Safari, Chrome, Opera */\n    -webkit-appearance: none;\n    font-size: 14px;\n    color: #080917;\n    background: url('./assets/images/dropdown.svg') no-repeat right white;\n    background-position-x: calc(100% - 16px);\n  }\n\n  select[data-smallerselect] {\n    background-position-x: calc(100% - 8px);\n  }\n\n  /* for IE */\n  select::-ms-expand {\n    display: none;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type='number'] {\n    -moz-appearance: textfield;\n    appearance: none;\n  }\n\n  .nav-item.active,\n  .nav-item:hover {\n    background-color: #ffffff;\n    border: 1px solid #dfe0df;\n    box-shadow: 0px 1px 2px 0px #344272;\n    border-radius: 8px;\n    color: #0b1c56;\n  }\n\n  .nav-sub-item {\n    background-color: #0e122a !important;\n    color: white;\n  }\n\n  .nav-sub-item-veldro {\n    background-color: #f2e6f7 !important;\n    color: #0e122a;\n  }\n\n  .nav-sub-item-veldro.active,\n  .nav-sub-item-veldro:hover {\n    background-color: #d4b8e0 !important;\n  }\n\n  .nav-item:hover svg path,\n  .sub-nav-item:hover svg path {\n    fill: #0b1c56 !important;\n  }\n\n  .nav-sub-item.active,\n  .nav-sub-item:hover {\n    background-color: #121635 !important;\n  }\n\n  .nav-item.active svg path {\n    fill: #0b1c56 !important;\n  }\n\n  .sub-nav-item.active {\n    background-color: #ffffff !important;\n    color: #0b1c56 !important;\n  }\n\n  .sub-nav-item.active svg path {\n    fill: #0b1c56 !important;\n  }\n\n  .nav-sub-item-profiled-risk {\n    background-color: #1e2060 !important;\n    color: #ffffff;\n  }\n\n  .nav-sub-item-profiled-risk.active,\n  .nav-sub-item-profiled-risk:hover {\n    background-color: #161c3f !important;\n  }\n\n  aside a {\n    white-space: nowrap;\n  }\n\n  .nav-sub-item-profiled-risk {\n    background-color: #1e2060 !important;\n    color: #ffffff;\n  }\n\n  .nav-sub-item-profiled-risk.active,\n  .nav-sub-item-profiled-risk:hover {\n    background-color: #161c3f !important;\n  }\n\n  .nav-sub-item-trypila {\n    background-color: #451480d4 !important;\n    color: #ffffff;\n  }\n\n  .nav-sub-item-trypila.active,\n  .nav-sub-item-trypila:hover {\n    background-color: #54159f !important;\n  }\n\n  .scrollbar-hide::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  aside svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .logo {\n    display: none;\n  }\n\n  /* activity log styling */\n  .activity-parent {\n    grid-template-columns: 0.8fr 4fr;\n  }\n\n  .activity-description:before {\n    transform: translate(-50%, -50%);\n  }\n}\n\n/* additional styling */\n\naside::-webkit-scrollbar,\n.custom-flow::-webkit-scrollbar,\n.lookup-modal::-webkit-scrollbar,\n.userApp::-webkit-scrollbar {\n  position: relative;\n  right: 40px;\n  width: 5px !important;\n}\n\naside::-webkit-scrollbar-track,\n.custom-flow::-webkit-scrollbar-track,\n.lookup-modal::-webkit-scrollbar-track,\n.userApp::-webkit-scrollbar-track {\n  background: none !important;\n}\n\naside::-webkit-scrollbar-thumb,\n.custom-flow::-webkit-scrollbar-thumb,\n.lookup-modal::-webkit-scrollbar-thumb,\n.userApp::-webkit-scrollbar-thumb {\n  background-color: #ceced2 !important;\n  border-radius: 10px !important;\n}\n\n.widget-footer {\n  background-image: url('../src/assets/images/widget-vector.svg');\n}\n\n[type='file'] {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute !important;\n  white-space: nowrap;\n  width: 1px;\n}\n\n[type='file'] + label {\n  color: #3f7cdb;\n  font-weight: 400;\n}\n\n[type='file']:focus + label,\n[type='file'] + label:hover {\n  cursor: pointer;\n}\n\n[type='file']:focus-visible + label {\n  outline: 2px solid #000;\n  border-radius: 2px;\n}\n\n/* custom react select styling */\n\n.react-select__input-container,\n.react-select-new-page__input-container {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.react-select__input {\n  height: auto !important;\n}\n\n.react-select__placeholder,\n.react-select-new-page__placeholder {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #8e90a9 !important;\n}\n\n.react-select__value-container,\n.react-select-new-page__value-container {\n  gap: 8px;\n  padding: 0 !important;\n}\n\n.react-select__value-container--is-multi {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.react-select__option,\n.react-select-new-page__option,\n.react-select__single-value,\n.react-select-new-page__single-value {\n  font-size: 14px !important;\n  color: #4a4a68 !important;\n}\n\n.react-select__option--is-focused,\n.react-select-new-page__option--is-focused,\n.react-select__option:hover .react-select-new-page__option:hover {\n  background-color: #f1f1f1 !important;\n}\n\n.react-select__option--is-selected,\n.react-select-new-page__option--is-selected {\n  background-color: #333442 !important;\n  color: #fff !important;\n}\n\n.apps-multi-select .react-select__option--is-selected,\n.apps-multi-select .react-select-new-page__option--is-selected {\n  background-color: var(--color-primary) !important;\n}\n\n.apps-multi-select .react-select__control {\n  min-height: 48px !important;\n}\n\n.creatable-multi-select .react-select__control--is-focused:active,\n.creatable-multi-select .react-select__control--is-focused:focus-within {\n  border-width: 0 !important;\n}\n\n.apps-multi-select .react-select__option--is-selected:hover,\n.apps-multi-select .react-select-new-page__option--is-selected:hover {\n  background-color: var(--color-primary) !important;\n}\n\n.apps-multi-select .react-select__option {\n  color: #080917 !important;\n  font-size: 13px !important;\n}\n\n.apps-multi-select .react-select__option--is-selected {\n  color: #fff !important;\n}\n\n.apps-multi-select .react-select__menu-list,\n.apps-multi-select .react-select__menu-list--is-multi {\n  padding: 8px !important;\n}\n\n.react-select__option--is-selected:hover,\n.react-select-new-page__option--is-selected:hover {\n  background-color: #333442 !important;\n  color: #fff !important;\n}\n\n.react-select__multi-value {\n  margin: 0 !important;\n}\n\n.react-select__clear-indicator,\n.react-select-new-page__clear-indicator {\n  display: none !important;\n}\n\n.react-select__control,\n.react-select-new-page__control {\n  padding-left: 16px !important;\n  outline: 1px !important;\n}\n\n.react-select__control:hover,\n.react-select-new-page__control:hover {\n  outline-color: #ceced2 !important;\n}\n\n.react-select__control--is-focused,\n.react-select-new-page__control--is-focused {\n  outline-color: var(--color-primary) !important;\n  outline-width: 1px !important;\n}\n\n.react-select__indicator-separator,\n.react-select-new-page__indicator-separator {\n  display: none !important;\n}\n\n.react-select__indicator,\n.react-select-new-page__indicator {\n  padding: 15px !important;\n  padding-right: 16px !important;\n}\n\n.react-react-select__menu > p {\n  text-align: left !important;\n}\n.react-select__menu {\n  z-index: 20 !important;\n}\n\n.white-select > div {\n  background-color: #fff !important;\n  text-align: left !important;\n}\n\n/* multiselect */\n.react-select__multi-value {\n  background-color: var(--color-primary) !important;\n  color: #d9e5f8;\n  border-radius: 25px !important;\n  flex-direction: row-reverse;\n  gap: 4px;\n  align-items: center !important;\n  padding: 3px 8px !important;\n  margin: 0 !important;\n}\n\n.react-select__multi-value__label {\n  color: inherit !important;\n  text-transform: uppercase;\n  font-size: 10px !important;\n  font-weight: 500;\n  line-height: 12px;\n  padding: 0 !important;\n  position: relative;\n}\n\n.react-select__multi-value__remove {\n  padding: 0 !important;\n}\n\n.react-select__multi-value__remove:hover {\n  background-color: transparent !important;\n}\n\n.react-select__control--is-focused:active,\n.react-select__control--is-focused:focus-within {\n  outline-color: var(--color-primary) !important;\n  outline-width: 1px !important;\n  border-color: var(--color-primary) !important;\n}\n\n.react-select-new-page__menu-list {\n  height: auto;\n}\n\n.react-select__group-heading span:first-child {\n  font-size: 10px !important;\n  font-weight: 500 !important;\n  color: #8e90a9 !important;\n}\n\n.creatable-multi-select .react-select__control {\n  background-color: #fff !important;\n  min-height: 48px !important;\n}\n\n.receive_webhook .creatable-multi-select .react-select__control {\n  background-color: white !important;\n}\n\n.creatable-multi-select .react-select__input {\n  font-size: 13px !important;\n}\n\n.creatable-multi-select .react-select__placeholder {\n  margin-bottom: -4px;\n}\n\n.creditcheck-select .react-select__control {\n  width: fit-content !important;\n  margin-left: auto !important;\n}\n\n.creditcheck-select .react-select__menu {\n  width: 70% !important;\n  right: 0 !important;\n}\n\n.react-select__menu {\n  z-index: 1000 !important;\n}\n\n.globalsearch .react-select__menu-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.globalsearch .react-select__option {\n  padding: 8px !important;\n}\n\n/* custom phone input styling */\n\n.phone-no-container {\n  outline: 1px solid #d5d5d5 !important;\n  border-radius: 4px !important;\n}\n\n.phone-no-container:active,\n.phone-no-container:focus-within {\n  outline: 1px solid #3f7cdb !important;\n}\n\n.phone-no-input {\n  height: 48px !important;\n  width: 100% !important;\n  background-color: #fff !important;\n  font-size: 13px !important;\n  border-width: 0 !important;\n  padding-left: 64px !important;\n  font-family: 'Inter', sans-serif;\n}\n\n.phone-no-input:active,\n.phone-no-input:focus-within {\n  border-radius: 8px !important;\n  border: none !important;\n}\n\n.flag-dropdown {\n  border-top: none !important;\n  border-bottom: none !important;\n  border-left: none !important;\n  background-color: #f9f9f9 !important;\n}\n\n.selected-flag {\n  padding-left: 16px !important;\n  width: 56px !important;\n}\n\n.flag {\n  margin-top: -6px !important;\n}\n\n.react-tel-input {\n  max-height: 48px !important;\n  display: flex !important;\n  align-items: center !important;\n  background: #fff !important;\n  border-radius: 8px !important;\n}\n\n.react-tel-input .selected-flag .arrow {\n  left: 24px !important;\n}\n\n.react-tel-input .country-list {\n  text-align: start !important;\n}\n\n.react-tel-input .country-list .country {\n  font-size: 13px !important;\n  color: #4a4a68 !important;\n  font-family: 'Inter', sans-serif;\n  font-weight: normal;\n  padding: 8px 12px !important;\n}\n\n.react-tel-input .country-list .country.highlight {\n  background-color: #fff !important;\n  color: #fff !important;\n}\n\n.react-tel-input .country-list .country.highlight .dial-code {\n  color: #fff !important;\n}\n\n.react-tel-input .country-list .search {\n  padding: 10px !important;\n}\n\n.react-tel-input .country-list .search-box {\n  padding: 8px !important;\n}\n\n.react-tel-input .country-list .no-entries-message {\n  font-family: 'Inter', sans-serif !important;\n  font-size: 13px !important;\n}\n\n.react-tel-input .form-control {\n  outline: 0.5px solid #d5d5d5 !important;\n  border-radius: 8px !important;\n}\n\n.react-tel-input .form-control:focus {\n  outline: 1px solid #3f7cdb !important;\n}\n\n/* react toastify styles */\n\n@media only screen and (max-width: 480px) {\n  .Toastify__toast-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n\n  :root {\n    --toastify-toast-min-height: 48px !important;\n  }\n}\n\n.Toastify__toast-body {\n  font-family: 'Inter', sans-serif !important;\n  font-weight: 500;\n}\n\n.Toastify__toast {\n  border-radius: 4px !important;\n}\n\n.Toastify__toast--success {\n  background-color: var(--color-primary) !important;\n  font-weight: 700 !important;\n  max-height: 20px !important;\n  font-size: 0.8rem;\n  color: white !important;\n}\n\n.Toastify__toast--error {\n  background-color: #bb371a !important;\n  font-weight: 700 !important;\n  font-size: 0.8rem;\n  color: white !important;\n}\n\n.Toastify__progress-bar {\n  visibility: hidden;\n}\n\n.Toastify__toast-icon {\n  display: none !important;\n}\n\n.Toastify__close-button svg {\n  fill: white !important;\n}\n\n.Toastify__toast-theme--light {\n  max-width: 100% !important;\n}\n\n/* datepicker */\n\n.lookup-filter .react-datepicker__input-container > input {\n  font-size: 10px !important;\n  font-weight: 500 !important;\n  outline: none !important;\n  height: 32px !important;\n  cursor: pointer !important;\n}\n\n.react-datepicker {\n  font-family: 'Inter', sans-serif !important;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-previous {\n  background: url(./assets/images/dropdown-nofill.svg) no-repeat;\n  border: none;\n  inset: 0 !important;\n  width: 16px;\n  height: 16px;\n}\n\n.react-datepicker__year-option .react-datepicker__navigation--years-upcoming {\n  background: url(./assets/images/dropdown-nofill.svg) no-repeat;\n  border: none;\n  transform: rotate(180deg);\n  inset: 0 !important;\n  width: 16px;\n  height: 16px;\n}\n\n.lookup-image {\n  background-position: center !important;\n  background-size: cover !important;\n  border-radius: 50%;\n  background-repeat: no-repeat !important;\n  display: inline-block;\n  height: 80px;\n  width: 80px;\n  object-fit: contain;\n}\n\n.page-limit {\n  display: flex;\n  align-items: center;\n  color: #5c688e;\n  font-size: 13px;\n}\n\n.page-limit button {\n  margin: 0 0.5rem;\n  position: relative;\n}\n\n.page-limit .dropdown {\n  position: absolute;\n  width: 100%;\n  color: #555;\n  background: white;\n  border-radius: 3px;\n  display: flex;\n  flex-direction: column;\n  z-index: 10;\n  top: 100%;\n  right: 0;\n  box-shadow: 0 5px 10px rgba(33, 33, 33, 0.12);\n}\n\n.page-limit .dropdown span {\n  padding: 5px;\n}\n\n.page-limit .dropdown span:hover {\n  background: #e3f5fa;\n}\n\n@keyframes skeleton-animation {\n  0% {\n    right: 100%;\n  }\n\n  50% {\n    right: -128px;\n  }\n\n  100% {\n    right: 100%;\n  }\n}\n\n.skeleton {\n  overflow: hidden;\n  width: 328px;\n  height: auto;\n  display: grid;\n  grid-template-columns: 128px 200px;\n  grid-gap: 8px;\n  position: relative;\n  margin-bottom: 16px;\n  /* margin-left: 7rem; */\n  background: #eee;\n}\n\n.skeleton:before {\n  display: block;\n  position: absolute;\n  width: 128px;\n  height: 78px;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0),\n    #fff,\n    rgba(255, 255, 255, 0)\n  );\n  content: '';\n  animation: skeleton-animation 1.25s infinite;\n}\n\n.skeleton .s-img {\n  width: 128px;\n  height: 78px;\n  background: #eee;\n  grid-row: 1 / 4;\n}\n\n.skeleton .s-line {\n  height: 10px;\n  background: #eee;\n}\n\n.skeleton .s-line.first {\n  width: 100%;\n}\n\n.skeleton .s-line.second {\n  width: 75%;\n}\n\n.skeleton .s-line.third {\n  width: 50%;\n}\n\n.widget-radios {\n  display: none;\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.widget-radios[type='checkbox'] + label {\n  color: #677189;\n  padding: 14px 32px !important;\n  background-color: #f6f6f8;\n  border: 1px solid #f6f6f8;\n  border-radius: 40px;\n  cursor: pointer;\n}\n\n.widget-radios[type='checkbox'] + label {\n  padding: 14px 24px;\n}\n\n.widget-radios[type='checkbox']:checked + label {\n  color: #1b2a4e !important;\n  padding: 14px 32px !important;\n  background-color: lightgray;\n  border: 1px solid #3977de;\n  border-radius: 40px;\n  cursor: pointer;\n}\n\n/* apexcharts  */\n.apexcharts-tooltip {\n  background: #fff !important;\n  color: #1b2a4e !important;\n  box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08),\n    0 8px 16px rgba(50, 50, 71, 0.06) !important;\n  border: 1px solid #fff !important;\n}\n\n.apexcharts-legend {\n  gap: 16px !important;\n  padding: 0 32px !important;\n}\n\n.apexcharts-legend-series {\n  display: flex !important;\n  align-items: flex-end !important;\n  gap: 4px;\n  margin: 0 !important;\n}\n\n.apexcharts-legend-marker {\n  margin-right: 0 !important;\n}\n\n.apexcharts-legend-text {\n  line-height: 12px !important;\n  text-transform: uppercase;\n  margin-top: 5px;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.hidden-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.hidden-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  overflow: auto;\n}\n\n.activeSettingsTab {\n  position: relative;\n  color: #3f7cdb !important;\n  display: inline-block;\n}\n\n.activeSettingsTab::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-bottom: 1px solid #3f7cdb;\n}\n\nprogress::-moz-progress-bar {\n  background: #3f7cdb;\n  border-radius: 50px;\n}\n\nprogress::-webkit-progress-value {\n  background: #3f7cdb;\n}\n\nprogress {\n  background-color: #eee;\n  width: 100%;\n  border-radius: 50px !important;\n  height: 20px;\n}\n\nprogress {\n  background-color: #eee;\n  border: 0;\n  height: 18px;\n  border-radius: 20px;\n}\n\nprogress::-webkit-progress-bar {\n  background-color: #eee;\n  border: 0;\n  height: 18px;\n  border-radius: 20px;\n}\n\nprogress::-webkit-progress-value {\n  border: 0;\n  height: 18px;\n  border-radius: 20px;\n}\n\nprogress::-moz-progress-bar {\n  background-color: #eee;\n  border: 0;\n  height: 18px;\n  border-radius: 20px;\n}\n\n.responsive-iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 80vh;\n}\n\n.truncated-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.liveness_slider {\n  width: 100%;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.liveness_slider input[type='range'] {\n  width: 100%;\n  height: 2px;\n  /* background-color: black; */\n  border: none;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.match_score input[type='range'] {\n  width: 100%;\n  height: 10px;\n  /* background-color: black; */\n  border: none;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.match_score input[type='range']::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.match_score input[type='range']::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 50%;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.print_aml .header,\n.print_aml .header-space {\n  height: 50px;\n}\n\n.print_aml .footer,\n.print_aml .footer-space {\n  height: 50px;\n}\n\n.print_aml .header {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.print_aml .footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n}\n\n@page {\n  margin: 10mm;\n}\n\n.pre {\n  padding: 10px 40px !important;\n  font-size: 13px !important;\n}\n\n.highlighter pre {\n  font-size: 13px;\n  padding: 20px 10px !important;\n  border-radius: 12px;\n}\n\n.add_project_select .react-select__control {\n  height: 38px;\n}\n.custom-questions-select .css-13cymwt-control {\n  height: 56px;\n  border-radius: 8px;\n  border: 1px solid #f9f9f9;\n  cursor: pointer;\n}\n.custom-questions-select .css-13cymwt-control:hover {\n  border: 1px solid #f9f9f9 !important;\n}\n.custom-questions-select .css-1u9des2-indicatorSeparator {\n  display: none;\n}\n.custom-questions-select .css-t3ipsp-control {\n  border: 1px solid #f9f9f9 !important;\n  box-shadow: none !important;\n  border-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 0 0 1px #f9f9f9;\n}\n.custom-questions-select .css-1nmdiq5-menu {\n  padding: 12px;\n  background-color: #f0f3ff;\n  border-radius: 8px;\n}\n.answer-option-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n}\n.answer-option-content.open {\n  max-height: 500px;\n}\n\n.add_project_select .react-select__placeholder {\n  color: #959595 !important;\n  font-weight: 400;\n}\n.add_project_select .react-select__indicator {\n  padding: 10px !important;\n}\n\n.project_line_chart .apexcharts-xaxis-label {\n  font-size: 10px;\n  text-transform: uppercase;\n}\n.project_line_chart .apexcharts-legend {\n  overflow: hidden;\n}\n.project_line_chart text:first-child {\n  transform: translate(0, 0) !important;\n}\n.project_line_chart text:last-child {\n  transform: translate(0, 0) !important;\n}\n\n.project_line_chart .apexcharts-yaxis-label {\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.required:after {\n  content: ' *';\n  color: #ca2b2b;\n}\n\n/* width */\n.listbox-scroll::-webkit-scrollbar {\n  width: 4px;\n  border-radius: 12px;\n}\n\n/* Track */\n.listbox-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 12px;\n}\n\n/* Handle */\n.listbox-scroll::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 12px;\n}\n\n/* Handle on hover */\n.listbox-scroll::-webkit-scrollbar-thumb:hover {\n  background: #555;\n  border-radius: 12px;\n}\n\n.select-verifications .react-select__control {\n  background: rgb(from var(--color-primary) r g b / 0.13);\n  border-color: rgb(from var(--color-primary) r g b / 0.23);\n}\n\n.select-verifications .react-select__option--is-selected {\n  background: var(--color-primary) !important;\n}\n\n.select-verifications .react-select__control .react-select__single-value,\n.select-verifications .react-select__control .react-select__placeholder {\n  color: var(--color-primary) !important;\n}\n\n.custom-questions-select .css-13cymwt-control {\n  height: 56px;\n  border-radius: 8px;\n  border: 1px solid #f9f9f9;\n  cursor: pointer;\n}\n.custom-questions-select .css-13cymwt-control:hover {\n  border: 1px solid #f9f9f9 !important;\n}\n.custom-questions-select .css-1u9des2-indicatorSeparator {\n  display: none;\n}\n.custom-questions-select .css-t3ipsp-control {\n  border: 1px solid #f9f9f9 !important;\n  /*box-shadow: none !important;*/\n  border-radius: 8px;\n  box-shadow: 0 0 0 1px #f9f9f9;\n}\n.custom-questions-select .css-1nmdiq5-menu {\n  padding: 12px;\n  background-color: #f0f3ff;\n  border-radius: 8px;\n}\n.answer-option-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n}\n.answer-option-content.open {\n  max-height: 500px;\n}\n\n.spinner {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: 2px solid #3f7cdb;\n  border-right-color: rgba(255, 255, 255, 0.3);\n  position: relative;\n  animation: spin 0.3s linear infinite;\n  -webkit-animation: spin 0.3s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.conditions-style::placeholder {\n  color: black !important;\n}\n.conditions-style:focus::placeholder {\n  color: #c2c2c2 !important;\n}\n.conditions-style::placeholder {\n  color: black !important;\n}\n.conditions-style:focus::placeholder {\n  color: #c2c2c2 !important;\n}\n\n.scrollbar-visible::-webkit-scrollbar {\n  width: 10px;\n}\n\n.scrollbar-visible::-webkit-scrollbar-track {\n  background: #d5d5d570;\n  border-radius: 10px;\n}\n\n.scrollbar-visible::-webkit-scrollbar-thumb {\n  background-color: #ffffff;\n  border-radius: 10px;\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n\n.scrollbar-visible::-webkit-scrollbar-thumb:hover {\n  background-color: #a8a8a8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
